import React, { useState, useEffect, useRef } from "react";
import { Container, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CustomerDetails from "../../SalesForm/CustomerDetails";
import InvoiceDetails from "../../SalesForm/InvoiceDetails";
import ProductDetails from "./ProductDetails";
import ProductTable from "./ProductTable";
import PaymentDetails from "./PaymentDetails";
import useProductHandlers from "../../SalesForm/hooks/useProductHandlers";
import useCalculations from "../../SalesForm/hooks/useCalculations";
import "./EstimateForm.css";
import baseURL from "../../../../../Url/NodeBaseURL";
import SalesFormSection from "../../SalesForm/SalesForm3Section";
import { pdf } from "@react-pdf/renderer";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PDFLayout from "../../SalesForm/TaxInvoiceA4";
import { useLocation } from "react-router-dom";
import { saveAs } from "file-saver";
import EstimateDetails from "../EstimateDetails";
import EstimateA4 from "../EstimateA4";
import { BlobProvider } from "@react-pdf/renderer";

const EstimateForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const estimateData = location.state?.estimateData;
  const [showPDFDownload, setShowPDFDownload] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [saving, setSaving] = useState(false);
  const [metal, setMetal] = useState("");
  const queryParams = new URLSearchParams(location.search);
  const resetEstimate = queryParams.get("reset") === "true";
  const trigger = queryParams.get("t");

  const [oldSalesData, setOldSalesData] = useState(
    JSON.parse(localStorage.getItem("oldSalesData")) || []
  );

  const [schemeSalesData, setSchemeSalesData] = useState(
    JSON.parse(localStorage.getItem("schemeSalesData")) || []
  );

  // 1️⃣ Try to get isEstimatePage from state (Estimates page)
  const isEstimatePageState = location.state?.isEstimatePage;

  // 2️⃣ Try to get isEstimatePage from URL query (Sales page)
  const searchParams = new URLSearchParams(location.search);
  const isEstimatePageQuery = searchParams.get("isEstimatePage");

  // 3️⃣ Determine final isEstimatePage
  const isEstimatePage =
    isEstimatePageState !== undefined
      ? isEstimatePageState
      : isEstimatePageQuery === "true"; //marre


  // Save to localStorage whenever data changes
  useEffect(() => {
    localStorage.setItem("oldSalesData", JSON.stringify(oldSalesData));
  }, [oldSalesData]);

  useEffect(() => {
    localStorage.setItem("schemeSalesData", JSON.stringify(schemeSalesData));
  }, [schemeSalesData]);

  // const [paymentDetails, setPaymentDetails] = useState(
  //   JSON.parse(localStorage.getItem('paymentDetails')) || {
  //     cash_amount: 0,
  //     card_amt: 0,
  //     chq: "",
  //     chq_amt: 0,
  //     online: "",
  //     online_amt: 0,
  //   }
  // );

  const {
    formData,
    setFormData,
    products,
    data,
    isQtyEditable,
    handleChange,
    handleBarcodeChange,
    handleProductChange,
    handleProductNameChange,
    handleMetalTypeChange,
    handleDesignNameChange,
    filteredDesignOptions,
    filteredPurityOptions,
    filteredMetalTypes,
    uniqueProducts,
    metaltypeOptions,
    purityOptions,
    categoryOptions,
    subcategoryOptions,
    designOptions,
    isBarcodeSelected,
    handleImageChange,
    image,
    fileInputRef,
    clearImage,
    captureImage,
    setShowWebcam,
    showWebcam,
    webcamRef,
    setShowOptions,
    showOptions,
    fetchCategory,
    fetchSubCategory,
    isManualTotalPriceChange,
    setIsManualTotalPriceChange,
    isTotalPriceCleared,
    setIsTotalPriceCleared,
    manualTotalPriceRef,
  } = useProductHandlers();

  const [repairDetails, setRepairDetails] = useState(() => {
    const savedData = localStorage.getItem(`repairDetails`);
    return savedData ? JSON.parse(savedData) : [];
  });
  //Reset on New
  useEffect(() => {
    if (resetEstimate) {
  

      // Clear form data
      setFormData({
        customer_id: "",
        mobile: "",
        account_name: "",
        email: "",
        address1: "",
        address2: "",
        city: "",
        pincode: "",
        state: "",
        state_code: "",
        aadhar_card: "",
        gst_in: "",
        pan_card: "",
        date: new Date(Date.now() + (5.5 * 60 * 60 * 1000)).toISOString().split("T")[0],// Set today's date
        estimate_number: "", // Keep blank or get new number via API
      });

      // Clear localStorage
      localStorage.removeItem(`repairDetails`);
      localStorage.removeItem(`paymentDetails`);
      localStorage.removeItem(`oldSalesData`);
      localStorage.removeItem(`schemeSalesData`);
      localStorage.removeItem(`discount`);

      // Clear in-memory state
      setRepairDetails([]);
      setOldSalesData([]);
      setSchemeSalesData([]);
      setPaymentDetails({
        cash_amount: 0,
        card_amt: 0,
        chq_amt: 0,
        online: 0,
        online_amt: 0,
      });
      setDiscount(0);
    }
  }, [resetEstimate, trigger]);
  useEffect(() => {

    localStorage.setItem(
      `repairDetails`,
      JSON.stringify(repairDetails)
    );
  }, [repairDetails]);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await fetch(`${baseURL}/get/account-details`);
        if (!response.ok) {
          throw new Error("Failed to fetch customers");
        }
        const result = await response.json();
        const filteredCustomers = result.filter(
          (item) =>
            item.account_group === "CUSTOMERS" ||
            item.account_group === "SUPPLIERS"
        );
        setCustomers(filteredCustomers);
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };

    fetchCustomers();
  }, []);

  // Fetch next estimate number only for new estimates
  useEffect(() => {
    const fetchNextEstimateNumber = async () => {
      // Only fetch if we don't have an estimate number (new estimate)
      if (!formData.estimate_number) {
        try {
          const response = await axios.get(
            `${baseURL}/Estimate/next-estimate-number`
          );
    
          setFormData((prev) => ({
            ...prev,
            estimate_number: response.data.nextEstimateNumber,
          }));
        } catch (error) {
          console.error("Error fetching estimate number:", error);
        }
      }
    };

    fetchNextEstimateNumber();
  }, [formData.estimate_number]);

  const [selectedMobile, setSelectedMobile] = useState("");
  const [uniqueInvoice, setUniqueInvoice] = useState([]);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [invoiceDetails, setInvoiceDetails] = useState(null);

  const [returnData, setReturnData] = useState({
    estimate_number: "",
  });

 useEffect(() => {
  // Set the default date value to the current date in dd-mm-yyyy format (IST)
  if (!returnData.date) {
    const currentDateUTC = new Date();
    const istDate = new Date(currentDateUTC.getTime() + 5.5 * 60 * 60 * 1000);

    setReturnData({
      ...returnData,
      date: formatDate(istDate),
    });
  }
}, [returnData, setReturnData]);

// Utility function to format date as dd-mm-yyyy
const formatDate = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};


  // Handle invoice number change
  const handleInvoiceChange = (e) => {
    const selectedInvoiceNumber = e.target.value;
    const selectedInvoice = filteredInvoices.find(
      (invoice) => invoice.estimate_number === selectedInvoiceNumber
    );

    if (selectedInvoice) {
      setReturnData({
        ...returnData,
        estimate_number: selectedInvoiceNumber,
        date: selectedInvoice.date ? formatDate(selectedInvoice.date) : "", // Format date
        terms: selectedInvoice.terms || "", // Set the terms from the selected invoice
      });
    } else {
      setReturnData({
        ...returnData,
        estimate_number: selectedInvoiceNumber,
        date: "",
        terms: "",
      });
    }
  };

  useEffect(() => {
    const fetchSales = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/get-unique-repair-details`
        );
        const filteredData = response.data.filter(
          (item) => item.transaction_status === "Sales"
        );
        setUniqueInvoice(filteredData);
        setFilteredInvoices(filteredData); // Initially, show all invoices
      } catch (error) {
        console.error("Error fetching repair details:", error);
      }
    };

    fetchSales();
  }, []);

  useEffect(() => {
    const fetchInvoiceDetails = async () => {
      if (!returnData.estimate_number) {
        setInvoiceDetails([]); // Ensure it's an empty array, not null
        return;
      }

      try {
        const response = await axios.get(
          `${baseURL}/getsales/${returnData.estimate_number}`
        );
        const filteredData = response.data.filter(
          (invoice) => invoice.status !== "Sale Returned"
        );

        setInvoiceDetails(filteredData || []); // Ensure it's always an array

      } catch (error) {
        console.error(
          `Error fetching details for invoice ${returnData.estimate_number}:`,
          error
        );
        setInvoiceDetails([]); // Set empty array on error
      }
    };

    fetchInvoiceDetails();
  }, [returnData.estimate_number]);

  const handleCustomerChange = (customerId) => {
    const customer = customers.find(
      (cust) => String(cust.account_id) === String(customerId)
    );

    if (customer) {
      setFormData((prevData) => ({
        ...prevData,
        customer_id: customerId,
        account_name: customer.account_name || "",
        mobile: customer.mobile || "",
        email: customer.email || "",
        address1: customer.address1 || "",
        address2: customer.address2 || "",
        city: customer.city || "",
        pincode: customer.pincode || "",
        state: customer.state || "",
        state_code: customer.state_code || "",
        aadhar_card: customer.aadhar_card || "",
        gst_in: customer.gst_in || "",
        pan_card: customer.pan_card || "",
        // keep estimate_number untouched
        estimate_number: prevData.estimate_number || "",
      }));
      setSelectedMobile(customer.mobile || "");

      const filtered = uniqueInvoice.filter(
        (invoice) =>
          invoice.customer_name === customer.account_name ||
          invoice.mobile === customer.mobile
      );
      setFilteredInvoices(filtered);
    } else {
      setFormData((prevData) => ({
        ...prevData,
        customer_id: "",
        account_name: "",
        mobile: "",
        email: "",
        address1: "",
        address2: "",
        city: "",
        pincode: "",
        state: "",
        state_code: "",
        aadhar_card: "",
        gst_in: "",
        pan_card: "",
        // preserve estimate_number
        estimate_number: prevData.estimate_number || "",
      }));
      setSelectedMobile("");
      setFilteredInvoices(uniqueInvoice);
    }
  };

  const [editIndex, setEditIndex] = useState(null);
  const [discount, setDiscount] = useState(() => {
    return parseFloat(localStorage.getItem(`discount`)) || ""; // Load discount from localStorage
  });
  const [isManualNetMode, setIsManualNetMode] = useState(false);

  useEffect(() => {
    localStorage.setItem(`discount`, discount); // Save to localStorage when discount changes
  }, [discount]);

  const applyDiscountToRepairDetails = (discountValue) => {
    const storedRepairDetails =
      JSON.parse(localStorage.getItem(`repairDetails`)) || [];

    const updatedRepairDetails = storedRepairDetails.map((item) => {
      const makingCharges = parseFloat(item.making_charges) || 0;
      const pieceCost = parseFloat(item.pieace_cost) || 0;
      const qty = parseFloat(item.qty) || 1;
      const taxPercent = parseFloat(item.tax_percent) || 1;
      const piece_taxable_amt = parseFloat(item.piece_taxable_amt) || 0;
      const rateAmt = parseFloat(item.rate_amt) || 0;
      const stonePrice = parseFloat(item.stone_price) || 0;
      const discountAmt = parseFloat(item.disscount) || 0;
      const hmCharges = parseFloat(item.hm_charges) || 0;
      const pricingType = item.pricing;
      const festivalDiscount = parseFloat(item.festival_discount) || 0;

      let calculatedDiscount = 0;

      if (pricingType === "By fixed") {
        const pieceTaxableAmt = pieceCost * qty;
        calculatedDiscount = (pieceTaxableAmt * discountValue) / 100;

        const originalPieceTaxableAmt = item.original_piece_taxable_amt
          ? parseFloat(item.original_piece_taxable_amt)
          : pieceTaxableAmt;

        const updatedPieceTaxableAmt =
          originalPieceTaxableAmt - calculatedDiscount - festivalDiscount;
        const taxAmt = (taxPercent * updatedPieceTaxableAmt) / 100;
        const totalPrice = updatedPieceTaxableAmt + taxAmt;

        return {
          ...item,
          original_piece_taxable_amt: originalPieceTaxableAmt.toFixed(2),
          disscount: calculatedDiscount.toFixed(2),
          disscount_percentage: discountValue,
          piece_taxable_amt: updatedPieceTaxableAmt.toFixed(2),
          tax_amt: taxAmt.toFixed(2),
          total_price: totalPrice.toFixed(2),
        };
      } else {
        calculatedDiscount = (makingCharges * discountValue) / 100;

        const previousTotalPrice = parseFloat(item.total_price) || 0;
        const originalTotalPrice = item.original_total_price
          ? parseFloat(item.original_total_price)
          : previousTotalPrice;

        const totalBeforeTax =
          rateAmt +
          stonePrice +
          makingCharges +
          hmCharges -
          calculatedDiscount -
          festivalDiscount;
        const taxAmt = (totalBeforeTax * taxPercent) / 100;
        const updatedTotalPrice = totalBeforeTax + taxAmt;

        return {
          ...item,
          original_total_price: originalTotalPrice.toFixed(2),
          disscount: calculatedDiscount.toFixed(2),
          disscount_percentage: discountValue,
          tax_amt: taxAmt.toFixed(2),
          total_price: updatedTotalPrice.toFixed(2),
        };
      }
    });

    setRepairDetails(updatedRepairDetails);
    localStorage.setItem(
      `repairDetails`,
      JSON.stringify(updatedRepairDetails)
    );
  };

  const handleDiscountChange = (e) => {
    const discountValue = parseFloat(e.target.value) || "";

    // if (discountValue > 15) {
    //   alert("Discount cannot be greater than 15%");
    //   return;
    // }

    setDiscount(discountValue);
    setManualNetAmount(0); // Reset manualNetAmount to exit manual mode
    setIsManualNetMode(false); // Ensure we're in normal discount mode
    applyDiscountToRepairDetails(discountValue); // Recalculate with new discount
  };

  const [festivalShowModal, festivalSetShowModal] = useState(false);
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleFestivalShowModal = () => festivalSetShowModal(true);
  const handleFestivalCloseModal = () => festivalSetShowModal(false);
  const [appliedOffers, setAppliedOffers] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/offers`);
        const allOffers = response.data;


        const today = new Date();

        
        // Filter offers that are currently valid (within date range)
        // Temporarily disable date validation to test auto-application
        const validOffers = allOffers.filter((offer) => {
          const validFrom = new Date(offer.valid_from);
          const validTo = new Date(offer.valid_to);
          const isDateValid = today >= validFrom && today <= validTo;
          
          
          
          // For now, accept all offers regardless of date to test auto-application
          return true; // Changed from isDateValid to true
        });

        // Separate applied and unapplied offers
        const appliedOffers = validOffers.filter(offer => 
          offer.offer_status && offer.offer_status.toLowerCase() === "applied"
        );
        const unappliedOffers = validOffers.filter(offer => 
          !offer.offer_status || offer.offer_status.toLowerCase() === "unapplied"
        );



        // Set unapplied offers for the modal
        setOffers(unappliedOffers);
        
        // Automatically apply any offers that are marked as "Applied" in the database
        if (appliedOffers.length > 0) {
          
          
          // Create a function to apply offers
          const applyOffersToItems = () => {
            appliedOffers.forEach((offer, index) => {

              try {
                // Call handleApply directly
                handleApply(offer, index);
                
              } catch (error) {
                console.error(`Error auto-applying offer ${offer.offer_name} (EstimateForm):`, error);
              }
            });
          };
          
          // Apply offers immediately
          applyOffersToItems();
          
          // Also try with delays as backup
          setTimeout(applyOffersToItems, 1000);
          setTimeout(applyOffersToItems, 3000);
          setTimeout(applyOffersToItems, 5000);
        } else {

        }


        setLoading(false);
      } catch (error) {
        console.error("Error fetching offers:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const [isAnyOfferApplied, setIsAnyOfferApplied] = useState(false);

  const handleApply = (selectedOffer, offerIndex) => {

    
    const storedRepairDetails =
      JSON.parse(localStorage.getItem(`repairDetails`)) || [];
    const currentOfferKey = `${selectedOffer._id}_${offerIndex}`;

    

    // Use current state if localStorage is empty but state has data
    let updatedRepairDetails = storedRepairDetails.length > 0 ? [...storedRepairDetails] : [...repairDetails];
    
    

    // If no items to apply offer to, just mark the offer as applied
    if (updatedRepairDetails.length === 0) {
      
      setAppliedOffers(prev => ({
        ...prev,
        [currentOfferKey]: true,
      }));
      setIsAnyOfferApplied(true);
      return;
    }

    updatedRepairDetails = updatedRepairDetails.map((item) => {
      const taxPercent = parseFloat(item.tax_percent) || 1;
      const pieceCost = parseFloat(item.pieace_cost) || 0;
      const qty = parseFloat(item.qty) || 1;
      const discountAmt = parseFloat(item.disscount) || 0;
      const pricingType = item.pricing;
      const rateAmt = parseFloat(item.rate_amt) || 0;
      const stonePrice = parseFloat(item.stone_price) || 0;
      const makingCharges = parseFloat(item.making_charges) || 0;
      const hmCharges = parseFloat(item.hm_charges) || 0;
      const grossWeight = parseFloat(item.gross_weight) || 0;

      const percentageDiscount =
        parseFloat(selectedOffer.discount_percentage) || 0;
      const rateDiscount = parseFloat(selectedOffer.discount_on_rate) || 0;
      const fixedPercentageDiscount =
        parseFloat(selectedOffer.discount_percent_fixed) || 0;
      const weightBasedDiscount = (rateDiscount / 10) * grossWeight;
      const totalDiscountValue =
        pricingType === "By fixed"
          ? fixedPercentageDiscount
          : percentageDiscount + weightBasedDiscount;

      if (pricingType === "By fixed") {
        const pieceTaxableAmt = pieceCost * qty;
        const originalPieceTaxableAmt = item.original_piece_taxable_amt
          ? parseFloat(item.original_piece_taxable_amt)
          : pieceTaxableAmt;

        const calculatedDiscount = (pieceTaxableAmt * totalDiscountValue) / 100;
        const updatedPieceTaxableAmt =
          originalPieceTaxableAmt - calculatedDiscount - discountAmt;
        const taxAmt = (taxPercent * updatedPieceTaxableAmt) / 100;
        const totalPrice = updatedPieceTaxableAmt + taxAmt;

        return {
          ...item,
          original_piece_taxable_amt: originalPieceTaxableAmt.toFixed(2),
          festival_discount: calculatedDiscount.toFixed(2),
          festival_discount_percentage: percentageDiscount.toFixed(2),
          festival_discount_on_rate: rateDiscount.toFixed(2),
          piece_taxable_amt: updatedPieceTaxableAmt.toFixed(2),
          tax_amt: taxAmt.toFixed(2),
          total_price: totalPrice.toFixed(2),
        };
      } else {
        const calculatedDiscount =
          (makingCharges * percentageDiscount) / 100 +
          (rateDiscount / 10) * grossWeight;
        const totalBeforeTax =
          rateAmt +
          stonePrice +
          makingCharges +
          hmCharges -
          calculatedDiscount -
          discountAmt;

        const taxAmt = (totalBeforeTax * taxPercent) / 100;
        const updatedTotalPrice = totalBeforeTax + taxAmt;

        return {
          ...item,
          original_total_price: item.original_total_price
            ? item.original_total_price
            : parseFloat(item.total_price).toFixed(2),
          festival_discount: calculatedDiscount.toFixed(2),
          festival_discount_percentage: percentageDiscount.toFixed(2),
          festival_discount_on_rate: rateDiscount.toFixed(2),
          tax_amt: taxAmt.toFixed(2),
          total_price: updatedTotalPrice.toFixed(2),
        };
      }
    });

    setRepairDetails(updatedRepairDetails);
    localStorage.setItem(
      `repairDetails`,
      JSON.stringify(updatedRepairDetails)
    );

    // Mark the offer as applied
    setAppliedOffers({
      [currentOfferKey]: true,
    });
    setIsAnyOfferApplied(true);
  };

  const [estimate, setEstimate] = useState([]);
  const [selectedEstimate, setSelectedEstimate] = useState("");
  const [estimateDetails, setEstimateDetails] = useState(null);
  const [stock, setStock] = useState(null);
  const [currentEstimateIndex, setCurrentEstimateIndex] = useState(-1);
  const [sortedEstimates, setSortedEstimates] = useState([]);
  const [Mode, setMode] = useState("create"); // Track if we're editing or creating

  useEffect(() => {
    const fetchEstimate = async () => {
      try {
        const response = await axios.get(`${baseURL}/Estimate/summary`);
        const estimates = response.data.summary;

        setEstimate(estimates);

        // Get date 24 hours ago (matching EstimateTable logic)
        const twentyFourHoursAgo = new Date();
        twentyFourHoursAgo.setHours(twentyFourHoursAgo.getHours() - 24);

        // Filter estimates for last 24 hours (matching EstimateTable logic)
        const filteredEstimates = estimates.filter((est) => {
          const estimateDate = new Date(est.uniqueData.created_at);
          // Show estimates from last 24 hours
          return estimateDate >= twentyFourHoursAgo;
        });

        // Sort estimates by date (newest first) and then by estimate number (newest first)
        const sorted = filteredEstimates.sort((a, b) => {
          const dateA = new Date(a.uniqueData.date);
          const dateB = new Date(b.uniqueData.date);
          if (dateA.getTime() !== dateB.getTime()) {
            return dateB.getTime() - dateA.getTime(); // Newest first
          }
          // If dates are same, sort by estimate number (newest first for navigation)
          const numA =
            parseInt(a.uniqueData.estimate_number.replace(/[^0-9]/g, "")) || 0;
          const numB =
            parseInt(b.uniqueData.estimate_number.replace(/[^0-9]/g, "")) || 0;
          return numB - numA; // Higher numbers first (EST101 before EST100)
        });

        setSortedEstimates(sorted);
      } catch (error) {
        console.error("Error fetching estimate details:", error);
      }
    };
    fetchEstimate();
  }, []);

  useEffect(() => {
    fetch(`${baseURL}/get/opening-tags-entry`) // Correct URL
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch stock entries");
        }
        return response.json();
      })
      .then((data) => {

        setStock(data.result); // Use data.result since the backend sends { result: [...] }
        
      })
      .catch((error) => {
        console.error("Error fetching stock entries:", error);
      });
  }, []);

  const fetchEstimateDetails = async (estimate_number) => {
    if (!estimate_number) return;

    try {
      const response = await axios.get(
        `${baseURL}/Estimate/${estimate_number}` //@
      );

      // First, update the state with the full estimate details
      setEstimateDetails(response.data);

      if (!stock) {

        return;
      }

      // Filter only matching repeatedData items
      const filteredData = response.data.repeatedData
        .filter((item) =>
          stock.some(
            (stockItem) =>
              stockItem.PCode_BarCode === item.code &&
              stockItem.Status === "Available"
          )
        )
        .map((item) => ({
          ...item,
          estimate_number: formData.estimate_number, // Add estimate_number from formData
          transaction_status: "Sales", // Add transaction_status as "Sales"
          date: formData.date,
        }));

      if (filteredData.length > 0) {
        // Store filtered data in localStorage
        localStorage.setItem(
          `repairDetails`,
          JSON.stringify(filteredData)
        );

        // Update state with filtered data
        setRepairDetails(filteredData);

        // Immediately retrieve and log stored data
        const storedData = JSON.parse(
          localStorage.getItem(`repairDetails`)
        );

      } else {
        // Clear localStorage if no matching data
        localStorage.removeItem(`repairDetails`);
        setRepairDetails([]); // Clear state
        console.log("No matching data found. LocalStorage cleared.");
      }
    } catch (error) {
      console.error("Error fetching selected estimate details:", error);
    }
  };

  const handleEstimateChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedEstimate(selectedValue);

    if (selectedValue) {
      fetchEstimateDetails(selectedValue);
      // Update current index
      const index = sortedEstimates.findIndex(
        (est) => est.uniqueData.estimate_number === selectedValue
      );

      setCurrentEstimateIndex(index);
    } else {
      setEstimateDetails(null);
      localStorage.removeItem(`repairDetails`);
      setRepairDetails([]);
      setCurrentEstimateIndex(-1);
    }
  };

  // Navigation functions
  const navigateToPreviousEstimate = async () => {


    if (currentEstimateIndex > 0) {
      const prevEstimate = sortedEstimates[currentEstimateIndex - 1];

      if (prevEstimate) {
        try {
          const response = await axios.get(
            `${baseURL}/Estimate/full-details/${prevEstimate.uniqueData.estimate_number}`
          );
          const data = response.data;

          // Update form data
          setFormData((prev) => ({
            ...prev,
            estimate_number: data.estimate?.estimate_number || "",
            date: data.estimate?.date
              ? new Date(data.estimate.date).toISOString().split("T")[0]
              : new Date().toISOString().split("T")[0],
            customer_id: data.account?.account_id || "",
            account_name: data.account?.account_name || "",
            mobile: data.account?.phone || data.account?.mobile || "",
            email: data.account?.email || "",
            address1: data.account?.address1 || "",
            address2: data.account?.address2 || "",
            city: data.account?.city || "",
            pincode: data.account?.pincode || "",
            state: data.account?.state || "",
            state_code: data.account?.state_code || "",
            aadhar_card: data.account?.aadhar_card || "",
            gst_in: data.account?.gst_in || "",
            pan_card: data.account?.pan_card || "",
          }));

          // Update payment details - ensure they are numbers
          setPaymentDetails({
            cash_amount: Number(data.estimate?.cash_amt || 0),
            card_amt: Number(data.estimate?.card_amt || 0),
            chq_amt: Number(data.estimate?.cheque_amt || 0),
            online_amt: Number(data.estimate?.online_amt || 0),
          });

          // Update products
          if (data.products && data.products.length > 0) {
            const mappedProducts = data.products.map((product) => {
              const grossWeight = parseFloat(product.gr_wt) || 0;
              const stoneWeight = parseFloat(product.st_wt) || 0;
              const weightBW = grossWeight - stoneWeight;
              const vaPercent = parseFloat(product.va_perc) || 0;
              const wastageWeight = (grossWeight * vaPercent) / 100;
              const totalWeightAV = weightBW + wastageWeight;
              const rate = parseFloat(product.rate) || 0;
              const rateAmt = rate * totalWeightAV;
              const stonePrice = parseFloat(product.stone_price) || 0;
              const makingCharges = parseFloat(product.mc) || 0;
              const hmCharges = parseFloat(product.hm_charges) || 60;
              const discount = parseFloat(product.discount) || 0;
              const festivalDiscount = parseFloat(product.fest_discount) || 0;
              const taxPercent = parseFloat(product.tax_perc) || 3;

              const totalBeforeTax =
                rateAmt +
                stonePrice +
                makingCharges +
                hmCharges -
                discount -
                festivalDiscount;
              const taxAmt = (totalBeforeTax * taxPercent) / 100;
              const totalPrice = totalBeforeTax + taxAmt;

              return {
                id: product.id || "",
                code: product.barcode || "",
                product_name: product.product_name || "",
                metal_type: product.metal || "",
                purity: product.purity || "",
                gross_weight: grossWeight.toFixed(2),
                stone_weight: stoneWeight.toFixed(2),
                va_percent: vaPercent.toFixed(2),
                total_weight_av: totalWeightAV.toFixed(2),
                weight_bw: weightBW.toFixed(2),
                wastage_weight: wastageWeight.toFixed(2),
                rate: rate.toFixed(2),
                rate_amt: rateAmt.toFixed(2),
                making_charges: makingCharges.toFixed(2),
                stone_price: stonePrice.toFixed(2),
                hm_charges: hmCharges.toFixed(2),
                disscount: discount.toFixed(2),
                festival_discount: festivalDiscount.toFixed(2),
                tax_percent: `${taxPercent}% GST`,
                tax_amt: taxAmt.toFixed(2),
                total_price: totalPrice.toFixed(2),
                imagePreview: product.image || "",
                status: product.status || "active",
                remarks: product.remarks || "",
                remarks_type: product.remarks_type || "",
                qty: (product.qty || 1).toString(),
                category: product.category || "",
                sub_category: product.sub_category || "",
                design_name: product.design_name || "",
                va_on: "Gross Weight",
                mc_on: "MC %",
                mc_per_gram: "0",
                pricing: "By Weight",
                piece_taxable_amt: totalBeforeTax.toFixed(2),
                sale_status: "Not Delivered",
                estimate_status: "Not Delivered",
                transaction_status: "Sales",
                date:
                  data.estimate?.date || new Date().toISOString().split("T")[0],
                estimate_number: data.estimate?.estimate_number || "",
              };
            });

            setRepairDetails(mappedProducts);
            localStorage.setItem(
              `repairDetails`,
              JSON.stringify(mappedProducts)
            );
          } else {
            setRepairDetails([]);
            localStorage.removeItem(`repairDetails`);
          }

          // Update current index
          setCurrentEstimateIndex(currentEstimateIndex - 1);
          setSelectedEstimate(prevEstimate.uniqueData.estimate_number);
        } catch (error) {
          console.error("Error navigating to previous estimate:", error);
          alert("Error loading previous estimate");
        }
      }
    }
  };

  const navigateToNextEstimate = async () => {


    if (currentEstimateIndex < sortedEstimates.length - 1) {
      const nextEstimate = sortedEstimates[currentEstimateIndex + 1];

      if (nextEstimate) {
        try {
          const response = await axios.get(
            `${baseURL}/Estimate/full-details/${nextEstimate.uniqueData.estimate_number}`
          );
          const data = response.data;

          // Update form data
          setFormData((prev) => ({
            ...prev,
            estimate_number: data.estimate?.estimate_number || "",
            date: data.estimate?.date
              ? new Date(data.estimate.date).toISOString().split("T")[0]
              : new Date().toISOString().split("T")[0],
            customer_id: data.account?.account_id || "",
            account_name: data.account?.account_name || "",
            mobile: data.account?.phone || data.account?.mobile || "",
            email: data.account?.email || "",
            address1: data.account?.address1 || "",
            address2: data.account?.address2 || "",
            city: data.account?.city || "",
            pincode: data.account?.pincode || "",
            state: data.account?.state || "",
            state_code: data.account?.state_code || "",
            aadhar_card: data.account?.aadhar_card || "",
            gst_in: data.account?.gst_in || "",
            pan_card: data.account?.pan_card || "",
          }));

          // Update payment details - ensure they are numbers
          setPaymentDetails({
            cash_amount: Number(data.estimate?.cash_amt || 0),
            card_amt: Number(data.estimate?.card_amt || 0),
            chq_amt: Number(data.estimate?.cheque_amt || 0),
            online_amt: Number(data.estimate?.online_amt || 0),
          });

          // Update products
          if (data.products && data.products.length > 0) {
            const mappedProducts = data.products.map((product) => {
              const grossWeight = parseFloat(product.gr_wt) || 0;
              const stoneWeight = parseFloat(product.st_wt) || 0;
              const weightBW = grossWeight - stoneWeight;
              const vaPercent = parseFloat(product.va_perc) || 0;
              const wastageWeight = (grossWeight * vaPercent) / 100;
              const totalWeightAV = weightBW + wastageWeight;
              const rate = parseFloat(product.rate) || 0;
              const rateAmt = rate * totalWeightAV;
              const stonePrice = parseFloat(product.stone_price) || 0;
              const makingCharges = parseFloat(product.mc) || 0;
              const hmCharges = parseFloat(product.hm_charges) || 60;
              const discount = parseFloat(product.discount) || 0;
              const festivalDiscount = parseFloat(product.fest_discount) || 0;
              const taxPercent = parseFloat(product.tax_perc) || 3;

              const totalBeforeTax =
                rateAmt +
                stonePrice +
                makingCharges +
                hmCharges -
                discount -
                festivalDiscount;
              const taxAmt = (totalBeforeTax * taxPercent) / 100;
              const totalPrice = totalBeforeTax + taxAmt;

              return {
                id: product.id || "",
                code: product.barcode || "",
                product_name: product.product_name || "",
                metal_type: product.metal || "",
                purity: product.purity || "",
                gross_weight: grossWeight.toFixed(2),
                stone_weight: stoneWeight.toFixed(2),
                va_percent: vaPercent.toFixed(2),
                total_weight_av: totalWeightAV.toFixed(2),
                weight_bw: weightBW.toFixed(2),
                wastage_weight: wastageWeight.toFixed(2),
                rate: rate.toFixed(2),
                rate_amt: rateAmt.toFixed(2),
                making_charges: makingCharges.toFixed(2),
                stone_price: stonePrice.toFixed(2),
                hm_charges: hmCharges.toFixed(2),
                disscount: discount.toFixed(2),
                festival_discount: festivalDiscount.toFixed(2),
                tax_percent: `${taxPercent}% GST`,
                tax_amt: taxAmt.toFixed(2),
                total_price: totalPrice.toFixed(2),
                imagePreview: product.image || "",
                status: product.status || "active",
                remarks: product.remarks || "",
                remarks_type: product.remarks_type || "",
                qty: (product.qty || 1).toString(),
                category: product.category || "",
                sub_category: product.sub_category || "",
                design_name: product.design_name || "",
                va_on: "Gross Weight",
                mc_on: "MC %",
                mc_per_gram: "0",
                pricing: "By Weight",
                piece_taxable_amt: totalBeforeTax.toFixed(2),
                sale_status: "Not Delivered",
                estimate_status: "Not Delivered",
                transaction_status: "Sales",
                date:
                  data.estimate?.date || new Date().toISOString().split("T")[0],
                estimate_number: data.estimate?.estimate_number || "",
              };
            });

            setRepairDetails(mappedProducts);
            localStorage.setItem(
              `repairDetails`,
              JSON.stringify(mappedProducts)
            );
          } else {
            setRepairDetails([]);
            localStorage.removeItem(`repairDetails`);
          }

          // Update current index
          setCurrentEstimateIndex(currentEstimateIndex + 1);
          setSelectedEstimate(nextEstimate.uniqueData.estimate_number);
        } catch (error) {
          console.error("Error navigating to next estimate:", error);
          alert("Error loading next estimate");
        }
      }
    }
  };

  const navigateToFirstEstimate = async () => {


    if (currentEstimateIndex > 0 && sortedEstimates.length > 0) {
      const firstEstimate = sortedEstimates[0];

      if (firstEstimate) {
        try {
          const response = await axios.get(
            `${baseURL}/Estimate/full-details/${firstEstimate.uniqueData.estimate_number}`
          );
          const data = response.data;

          // Update form data
          setFormData((prev) => ({
            ...prev,
            estimate_number: data.estimate?.estimate_number || "",
            date: data.estimate?.date
              ? new Date(data.estimate.date).toISOString().split("T")[0]
              : new Date().toISOString().split("T")[0],
            customer_id: data.account?.account_id || "",
            account_name: data.account?.account_name || "",
            mobile: data.account?.phone || data.account?.mobile || "",
            email: data.account?.email || "",
            address1: data.account?.address1 || "",
            address2: data.account?.address2 || "",
            city: data.account?.city || "",
            pincode: data.account?.pincode || "",
            state: data.account?.state || "",
            state_code: data.account?.state_code || "",
            aadhar_card: data.account?.aadhar_card || "",
            gst_in: data.account?.gst_in || "",
            pan_card: data.account?.pan_card || "",
          }));

          // Update payment details - ensure they are numbers
          setPaymentDetails({
            cash_amount: Number(data.estimate?.cash_amt || 0),
            card_amt: Number(data.estimate?.card_amt || 0),
            chq_amt: Number(data.estimate?.cheque_amt || 0),
            online_amt: Number(data.estimate?.online_amt || 0),
          });

          // Update products
          if (data.products && data.products.length > 0) {
            const mappedProducts = data.products.map((product) => {
              const grossWeight = parseFloat(product.gr_wt) || 0;
              const stoneWeight = parseFloat(product.st_wt) || 0;
              const weightBW = grossWeight - stoneWeight;
              const vaPercent = parseFloat(product.va_perc) || 0;
              const wastageWeight = (grossWeight * vaPercent) / 100;
              const totalWeightAV = weightBW + wastageWeight;
              const rate = parseFloat(product.rate) || 0;
              const rateAmt = rate * totalWeightAV;
              const stonePrice = parseFloat(product.stone_price) || 0;
              const makingCharges = parseFloat(product.mc) || 0;
              const hmCharges = parseFloat(product.hm_charges) || 60;
              const discount = parseFloat(product.discount) || 0;
              const festivalDiscount = parseFloat(product.fest_discount) || 0;
              const taxPercent = parseFloat(product.tax_perc) || 3;

              const totalBeforeTax =
                rateAmt +
                stonePrice +
                makingCharges +
                hmCharges -
                discount -
                festivalDiscount;
              const taxAmt = (totalBeforeTax * taxPercent) / 100;
              const totalPrice = totalBeforeTax + taxAmt;

              return {
                id: product.id || "",
                code: product.barcode || "",
                product_name: product.product_name || "",
                metal_type: product.metal || "",
                purity: product.purity || "",
                gross_weight: grossWeight.toFixed(2),
                stone_weight: stoneWeight.toFixed(2),
                va_percent: vaPercent.toFixed(2),
                total_weight_av: totalWeightAV.toFixed(2),
                weight_bw: weightBW.toFixed(2),
                wastage_weight: wastageWeight.toFixed(2),
                rate: rate.toFixed(2),
                rate_amt: rateAmt.toFixed(2),
                making_charges: makingCharges.toFixed(2),
                stone_price: stonePrice.toFixed(2),
                hm_charges: hmCharges.toFixed(2),
                disscount: discount.toFixed(2),
                festival_discount: festivalDiscount.toFixed(2),
                tax_percent: `${taxPercent}% GST`,
                tax_amt: taxAmt.toFixed(2),
                total_price: totalPrice.toFixed(2),
                imagePreview: product.image || "",
                status: product.status || "active",
                remarks: product.remarks || "",
                remarks_type: product.remarks_type || "",
                qty: (product.qty || 1).toString(),
                category: product.category || "",
                sub_category: product.sub_category || "",
                design_name: product.design_name || "",
                va_on: "Gross Weight",
                mc_on: "MC %",
                mc_per_gram: "0",
                pricing: "By Weight",
                piece_taxable_amt: totalBeforeTax.toFixed(2),
                sale_status: "Not Delivered",
                estimate_status: "Not Delivered",
                transaction_status: "Sales",
                date:
                  data.estimate?.date || new Date().toISOString().split("T")[0],
                estimate_number: data.estimate?.estimate_number || "",
              };
            });

            setRepairDetails(mappedProducts);
            localStorage.setItem(
              `repairDetails`,
              JSON.stringify(mappedProducts)
            );
          } else {
            setRepairDetails([]);
            localStorage.removeItem(`repairDetails`);
          }

          // Update current index to 0 (first)
          setCurrentEstimateIndex(0);
          setSelectedEstimate(firstEstimate.uniqueData.estimate_number);
        } catch (error) {
          console.error("Error navigating to first estimate:", error);
          alert("Error loading first estimate");
        }
      }
    }
  };

  const navigateToLastEstimate = async () => {


    if (
      currentEstimateIndex < sortedEstimates.length - 1 &&
      sortedEstimates.length > 0
    ) {
      const lastEstimate = sortedEstimates[sortedEstimates.length - 1];

      if (lastEstimate) {
        try {
          const response = await axios.get(
            `${baseURL}/Estimate/full-details/${lastEstimate.uniqueData.estimate_number}`
          );
          const data = response.data;

          // Update form data
          setFormData((prev) => ({
            ...prev,
            estimate_number: data.estimate?.estimate_number || "",
            date: data.estimate?.date
              ? new Date(data.estimate.date).toISOString().split("T")[0]
              : new Date().toISOString().split("T")[0],
            customer_id: data.account?.account_id || "",
            account_name: data.account?.account_name || "",
            mobile: data.account?.phone || data.account?.mobile || "",
            email: data.account?.email || "",
            address1: data.account?.address1 || "",
            address2: data.account?.address2 || "",
            city: data.account?.city || "",
            pincode: data.account?.pincode || "",
            state: data.account?.state || "",
            state_code: data.account?.state_code || "",
            aadhar_card: data.account?.aadhar_card || "",
            gst_in: data.account?.gst_in || "",
            pan_card: data.account?.pan_card || "",
          }));

          // Update payment details - ensure they are numbers
          setPaymentDetails({
            cash_amount: Number(data.estimate?.cash_amt || 0),
            card_amt: Number(data.estimate?.card_amt || 0),
            chq_amt: Number(data.estimate?.cheque_amt || 0),
            online_amt: Number(data.estimate?.online_amt || 0),
          });

          // Update products
          if (data.products && data.products.length > 0) {
            const mappedProducts = data.products.map((product) => {
              const grossWeight = parseFloat(product.gr_wt) || 0;
              const stoneWeight = parseFloat(product.st_wt) || 0;
              const weightBW = grossWeight - stoneWeight;
              const vaPercent = parseFloat(product.va_perc) || 0;
              const wastageWeight = (grossWeight * vaPercent) / 100;
              const totalWeightAV = weightBW + wastageWeight;
              const rate = parseFloat(product.rate) || 0;
              const rateAmt = rate * totalWeightAV;
              const stonePrice = parseFloat(product.stone_price) || 0;
              const makingCharges = parseFloat(product.mc) || 0;
              const hmCharges = parseFloat(product.hm_charges) || 60;
              const discount = parseFloat(product.discount) || 0;
              const festivalDiscount = parseFloat(product.fest_discount) || 0;
              const taxPercent = parseFloat(product.tax_perc) || 3;

              const totalBeforeTax =
                rateAmt +
                stonePrice +
                makingCharges +
                hmCharges -
                discount -
                festivalDiscount;
              const taxAmt = (totalBeforeTax * taxPercent) / 100;
              const totalPrice = totalBeforeTax + taxAmt;

              return {
                id: product.id || "",
                code: product.barcode || "",
                product_name: product.product_name || "",
                metal_type: product.metal || "",
                purity: product.purity || "",
                gross_weight: grossWeight.toFixed(2),
                stone_weight: stoneWeight.toFixed(2),
                va_percent: vaPercent.toFixed(2),
                total_weight_av: totalWeightAV.toFixed(2),
                weight_bw: weightBW.toFixed(2),
                wastage_weight: wastageWeight.toFixed(2),
                rate: rate.toFixed(2),
                rate_amt: rateAmt.toFixed(2),
                making_charges: makingCharges.toFixed(2),
                stone_price: stonePrice.toFixed(2),
                hm_charges: hmCharges.toFixed(2),
                disscount: discount.toFixed(2),
                festival_discount: festivalDiscount.toFixed(2),
                tax_percent: `${taxPercent}% GST`,
                tax_amt: taxAmt.toFixed(2),
                total_price: totalPrice.toFixed(2),
                imagePreview: product.image || "",
                status: product.status || "active",
                remarks: product.remarks || "",
                remarks_type: product.remarks_type || "",
                qty: (product.qty || 1).toString(),
                category: product.category || "",
                sub_category: product.sub_category || "",
                design_name: product.design_name || "",
                va_on: "Gross Weight",
                mc_on: "MC %",
                mc_per_gram: "0",
                pricing: "By Weight",
                piece_taxable_amt: totalBeforeTax.toFixed(2),
                sale_status: "Not Delivered",
                estimate_status: "Not Delivered",
                transaction_status: "Sales",
                date:
                  data.estimate?.date || new Date().toISOString().split("T")[0],
                estimate_number: data.estimate?.estimate_number || "",
              };
            });

            setRepairDetails(mappedProducts);
            localStorage.setItem(
              `repairDetails`,
              JSON.stringify(mappedProducts)
            );
          } else {
            setRepairDetails([]);
            localStorage.removeItem(`repairDetails`);
          }

          // Update current index to last
          setCurrentEstimateIndex(sortedEstimates.length - 1);
          setSelectedEstimate(lastEstimate.uniqueData.estimate_number);
        } catch (error) {
          console.error("Error navigating to last estimate:", error);
          alert("Error loading last estimate");
        }
      }
    }
  };

  const applyDiscountAmountToRepairDetails = async (discountAmount) => {


    // get the total making charge - fix the syntax error
    const totalMakingCharges = repairDetails.reduce((sum, item) => {
      if (!item) return sum; // Skip if item is undefined
      
      const makingCharge = parseFloat(item.making_charges) || 0;

      return sum + makingCharge;
    }, 0);


    // If no making charges, try to use total price as base
    if (totalMakingCharges === 0) {
      const totalPrice = repairDetails.reduce(
        (sum, item) => {
          if (!item) return sum; // Skip if item is undefined
          return sum + (parseFloat(item.total_price) || 0);
        },
        0
      );


      if (totalPrice > 0) {
        // Calculate discount percentage based on total price
        const discountPercentage = (discountAmount / totalPrice) * 100;


        // Set the discount to the discount percentage
        setDiscount(discountPercentage);
        applyDiscountToRepairDetails(discountPercentage);
        return;
      }
    }

    // check what will the % of discount amount on total making charges
    const discountPercentage = (discountAmount / totalMakingCharges) * 100;


    // set the discount to the discount percentage
    setDiscount(discountPercentage);
    applyDiscountToRepairDetails(discountPercentage);
  };

  const [orderData, setOrderData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState("");
  const [autoEditIndex, setAutoEditIndex] = useState(null);
  const [autoUpdateInProgress, setAutoUpdateInProgress] = useState(false);

  const fetchOrders = async () => {
    try {
      const response = await axios.get(`${baseURL}/get-unique-order-details`);
      

      const filteredData = response.data.filter(
        (item) =>
          (item.transaction_status === "Orders" ||
            item.transaction_status === "ConvertedInvoice") &&
          item.invoice !== "Converted"
      );

      
      setOrderData(filteredData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching repair details:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
    // Only call handleViewDetails if we have a valid order number
    // handleViewDetails(); // Removed this call as it was causing 404 errors
  }, []);

  const handleViewDetails = async (order_number) => {
    // Skip if order_number is undefined or null
    if (!order_number) {

      return;
    }

    try {
      const response = await axios.get(
        `${baseURL}/get-order-details/${order_number}`
      );
      

      // Filter repeatedData to include only items where transaction_status is "Orders"
      const filteredData = response.data.repeatedData.filter(
        (item) => item.transaction_status === "Orders"
      );

      // Check if any item in repeatedData has invoice === "Converted"
      const isInvoiceConverted = filteredData.some(
        (item) => item.invoice === "Converted"
      );
      

      // Set state with filtered repeatedData and invoice status
      setOrderDetails({
        ...response.data,
        repeatedData: filteredData,
        isInvoiceConverted,
      });

      setShowModal(true);
    } catch (error) {
      console.error("Error fetching repair details:", error);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setOrderDetails(null);
  };

  const fetchOrderDetails = async (order_number) => {
    try {
      const response = await axios.get(
        `${baseURL}/get-order-details/${order_number}`
      );

      // Filter only matching repeatedData items
      const filteredData = response.data.repeatedData.map((item) => ({
        ...item,
        estimate_number: formData.estimate_number, // Add estimate_number from formData
        transaction_status: "Orders", // Add transaction_status as "Sales"
        date: formData.date,
        // invoice: 'Converted',
      }));

      if (filteredData.length > 0) {
        // Store filtered data in localStorage
        localStorage.setItem(
          `repairDetails`,
          JSON.stringify(filteredData)
        );

        // Update state with filtered data
        setRepairDetails(filteredData);
        setAutoEditIndex(0);

        // Immediately retrieve and log stored data
        const storedData = JSON.parse(
          localStorage.getItem(`repairDetails`)
        );
        console.log("Stored repairDetails:", storedData);
        return filteredData;
      } else {
        // Clear localStorage if no matching data
        localStorage.removeItem(`repairDetails`);
        setRepairDetails([]); // Clear state
        console.log("No matching data found. LocalStorage cleared.");
      }
    } catch (error) {
      console.error("Error fetching selected estimate details:", error);
    }
  };

  const handleOrderChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedOrder(selectedValue);

    if (selectedValue) {
      fetchOrderDetails(selectedValue);
    } else {
      setOrderDetails(null);
      localStorage.removeItem(`repairDetails`);
      setRepairDetails([]);
    }
  };

  const handleOrderCheckboxChange = async (e, order_number) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      // Fetch order details
      const orderDetails = await fetchOrderDetails(order_number);

      // Redirect to Order page with order details in state
      
      navigate("/orders", { state: { orderDetails } });
      // set orderDetails in localStorage
      localStorage.setItem("orderDetails", JSON.stringify(orderDetails));
    } else {
      // Clear selection
      setOrderDetails([]);
      setSelectedOrder("");
      setAutoEditIndex(null);
    }
  };

  useEffect(() => {
    if (repairDetails.length > 0 && autoEditIndex !== null) {
      handleEdit(autoEditIndex); // Trigger edit for current index
      setAutoUpdateInProgress(true); // Enable update trigger
    }
  }, [repairDetails, autoEditIndex]);

  useEffect(() => {
    if (autoUpdateInProgress) {
      handleUpdate(); // Update after editing
      setAutoUpdateInProgress(false); // Reset update trigger
    }
  }, [formData]);

  useEffect(() => {
    if (!autoUpdateInProgress && autoEditIndex !== null) {
      const nextIndex = autoEditIndex + 1;
      if (nextIndex < repairDetails.length) {
        setAutoEditIndex(nextIndex); // Proceed to next item
      } else {
        setAutoEditIndex(null); // Finished all updates

      }
    }
  }, [autoUpdateInProgress]);

  const [repairs, setRepairs] = useState([]);
  const [selectedRepairs, setSelectedRepairs] = useState({});

  const fetchRepairs = async () => {
    try {
      const response = await axios.get(`${baseURL}/get/repairs`);
      setRepairs(response.data);

    } catch (error) {
      console.error("Error fetching repairs:", error);
    }
  };

  useEffect(() => {
    fetchRepairs();
  }, []);

  const fetchRepairDetails = async (repair) => {
    try {
      const storageKey = `repairDetails`;

      // Create new filtered entry with necessary fields
      const filteredData = [
        {
          sub_category: repair.item,
          product_name: repair.item,
          customer_id: repair.customer_id,
          account_name: repair.account_name,
          mobile: repair.mobile,
          email: repair.email,
          address1: repair.address1,
          address2: repair.address2,
          city: repair.city,
          metal_type: repair.metal_type,
          purity: repair.purity,
          category: repair.category,
          gross_weight: "1",
          stone_weight: "0",
          stone_price: "0",
          weight_bw: "0",
          va_on: "Gross Weight",
          va_percent: "0",
          wastage_weight: "0",
          total_weight_av: "1",
          mc_on: "MC %",
          disscount_percentage: "0",
          disscount: "0",
          mc_per_gram: "0",
          making_charges: "0",
          printing_purity: repair.purity,
          selling_purity: repair.purity,
          qty: repair.qty,
          total_price: repair.total_amt,
          repair_no: repair.repair_no,
          estimate_number: formData.estimate_number,
          transaction_status: "Repairs",
          date: formData.date,
          invoice: "Converted",
          rate: repair.total_amt,
          tax_percent: "0",
          tax_amt: "0",
          hm_charges: "0",
          remarks_type: formData.remarks_type || "",
        },
      ];

      // Store in localStorage
      localStorage.setItem(storageKey, JSON.stringify(filteredData));

      // Update state
      setRepairDetails(filteredData);
      setAutoEditIndex(0);

      // Debug log
      const storedData = JSON.parse(localStorage.getItem(storageKey));
      

      return filteredData;
    } catch (error) {
      console.error("Error fetching repair details:", error);
    }
  };

  const handleRepairCheckboxChange = async (e, repair_no) => {
    const isChecked = e.target.checked;
    const storageKey = `repairDetails`;

    const repair = repairs.find((r) => r.repair_no === repair_no);
    if (!repair) return console.warn("Repair not found");

    if (isChecked) {
      localStorage.removeItem(storageKey);
      setRepairDetails([]);
      setSelectedRepairs({});

      await fetchRepairDetails(repair);

      setSelectedRepairs((prev) => ({
        ...prev,
        [repair.repair_no]: true,
      }));

      setSelectedOrder(""); // Optional reset
    } else {
      localStorage.removeItem(storageKey);
      setRepairDetails([]);
      setSelectedRepairs((prev) => {
        const updated = { ...prev };
        delete updated[repair.repair_no];
        return updated;
      });
    }
  };

  const handleAdd = () => {
    const storedRepairDetails =
      JSON.parse(localStorage.getItem(`repairDetails`)) || [];

    // Add new repair detail
    const updatedRepairDetails = [
      ...repairDetails,
      {
        ...formData,
        pieace_cost:
          formData.pieace_cost && parseFloat(formData.pieace_cost) > 0
            ? parseFloat(formData.pieace_cost).toFixed(2)
            : null,
        rate:
          formData.rate && parseFloat(formData.rate) > 0
            ? parseFloat(formData.rate).toFixed(2)
            : "",
        imagePreview: formData.imagePreview,
      },
    ];

    setRepairDetails(updatedRepairDetails);
    localStorage.setItem(
      `repairDetails`,
      JSON.stringify(updatedRepairDetails)
    );

    // Reset form data
    setFormData((prevData) => ({
      ...prevData,
      disscount: "",
      disscount_percentage: "",
      pieace_cost: "",
      imagePreview: null,
      sale_status: "Not Delivered",
      piece_taxable_amt: "",
      festival_discount: "",
    }));

    resetProductFields();

    // Automatically apply the first available offer every time (regardless of isAnyOfferApplied)
    // if (offers.length > 0) {
    //   handleApply(offers[0], 0); // Apply the first offer
    // }
  };

  const handleEdit = (index) => {
    setEditIndex(index);

    const item = repairDetails[index];
    const pieceCost = parseFloat(item.pieace_cost) || 0;
    const qty = parseFloat(item.qty) || 1;
    const pieceTaxableAmt = parseFloat(item.piece_taxable_amt).toFixed(2);

    
    setFormData((prevFormData) => ({
      ...prevFormData,
      ...item,
      pieace_cost: pieceCost > 0 ? pieceCost.toFixed(2) : "",
      rate:
        item.rate && parseFloat(item.rate) > 0
          ? parseFloat(item.rate).toFixed(2)
          : "",
      piece_taxable_amt: pieceTaxableAmt,
      making_charges: item.making_charges
    }));
  };

  const handleUpdate = () => {
    const updatedDetails = repairDetails.map((item, index) =>
      index === editIndex ? { ...formData } : item
    );
    setRepairDetails(updatedDetails);
    setEditIndex(null);
    resetProductFields();
  };

  const handleDelete = (indexToDelete) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      setRepairDetails(
        repairDetails.filter((_, index) => index !== indexToDelete)
      );
      alert("Product deleted successfully");
    }
  };

  const resetProductFields = () => {
    setFormData((prev) => ({
      ...prev,
      code: "",
      product_id: "",
      remarks_type: "",
      remarks: "",
      metal: "",
      product_name: "",
      metal_type: "",
      design_name: "",
      purity: "",
      selling_purity: "",
      printing_purity: "",
      category: "",
      sub_category: "",
      gross_weight: "",
      stone_weight: "",
      weight_bw: "",
      stone_price: "",
      va_on: "Gross Weight",
      va_percent: "",
      wastage_weight: "",
      total_weight_av: "",
      mc_on: "MC %",
      mc_per_gram: "",
      making_charges: "",
      disscount_percentage: "",
      disscount: "",
      rate: "",
      rate_amt: "",
      pricing: "By Weight",
      tax_percent: "03% GST",
      tax_amt: "",
      hm_charges: "60.00",
      total_price: "",
      qty: "",
      imagePreview: null,
      remarks: "",
      sale_status: "Delivered",
      estimate_status: "Not Delivered",
      piece_taxable_amt: "",
      festival_discount: "",
    }));
  };

  // Calculate totalPrice (sum of total_price from all repairDetails)
  const totalPrice = repairDetails.reduce(
    (sum, item) => {
      if (!item) return sum; // Skip if item is undefined
      return sum + parseFloat(item.total_price || 0);
    },
    0
  );

  const [oldTableData, setOldTableData] = useState(() => {
    const savedData = localStorage.getItem(`oldTableData`);
    return savedData ? JSON.parse(savedData) : [];
  });

  const [schemeTableData, setSchemeTableData] = useState(() => {
    const savedData = localStorage.getItem(`schemeTableData`);
    return savedData ? JSON.parse(savedData) : [];
  });

  const resetForm = () => {
    setFormData({
      customer_id: "",
      mobile: "",
      account_name: "",
      email: "",
      address1: "",
      address2: "",
      city: "",
      pincode: "",
      state: "",
      state_code: "",
      aadhar_card: "",
      gst_in: "",
      pan_card: "",
      date: "",
      estimate_number: "",
    });
    setPaymentDetails({
      cash_amount: 0,
      card_amt: 0,
      chq: "",
      chq_amt: 0,
      online: "",
      online_amt: 0,
    });
  };

  const [totalAdvanceAmount, setTotalAdvanceAmount] = useState(0);

  useEffect(() => {
    if (repairDetails && repairDetails.length > 0) {
      const lastRepair = repairDetails[repairDetails.length - 1];
      if (lastRepair.advance_amt) {
        try {
          const advances = JSON.parse(lastRepair.advance_amt);
          setTotalAdvanceAmount(
            advances.reduce((sum, entry) => sum + Number(entry.amount || 0), 0)
          );
        } catch {
          setTotalAdvanceAmount(0);
        }
      } else {
        setTotalAdvanceAmount(0);
      }
    }
  }, [repairDetails]);
  const resetSaleReturnForm = () => {
    setReturnData({
      estimate_number: "",
    });
  };

  const handleBack = () => {
    navigate("/salestable");
  };

  // const handleAddCustomer = () => {
  //   navigate("/customermaster", { state: { from: `/sales?tabId=${tabId}` } });
  // };

  const handleAddCustomer = (mobile) => {

    navigate("/customermaster", {
      state: {
        from: `/sales`,
        mobile: mobile, // Pass the mobile number here
      },
    });
  };

  const [manualNetAmount, setManualNetAmount] = useState(0);
  const [manualNetPayAmount, setManualNetPayAmount] = useState(0);
  const [oldItemsAmount, setOldItemsAmount] = useState(0);

  useEffect(() => {
    const fetchOldItems = async () => {
      try {

        if (orderDetails?.[0]?.order_number) {
          
          const response = await axios.get(
            `${baseURL}/get/olditems/${orderDetails[0].order_number}`
          );
          
          if (response.data && Array.isArray(response.data)) {
            setOldSalesData(response.data);
            const total = response.data.reduce(
              (sum, item) => sum + parseFloat(item.total_amount || 0),
              0
            );
            setOldItemsAmount(total);
            
          }
        } else {
          
        }
      } catch (error) {
        console.error("Error fetching old items:", error);
      }
    };
    fetchOldItems();
  }, [orderDetails]);

  // Update oldItemsAmount whenever oldSalesData changes (from URD Purchase)
  useEffect(() => {
    const total = oldSalesData.reduce(
      (sum, item) => sum + parseFloat(item.total_amount || 0),
      0
    );
    setOldItemsAmount(total);
    
  }, [oldSalesData]);

  // Fetch old items when estimate is loaded
  useEffect(() => {
    const fetchOldItemsForEstimate = async () => {
      if (formData.estimate_number) {
        try {
          
          const response = await axios.get(
            `${baseURL}/get/olditems/${formData.estimate_number}`
          );
          

          if (response.data && response.data.length > 0) {
            // Map the response data to the format expected by OldSalesForm
            const mappedOldItems = response.data.map((item) => ({
              product: item.product || "",
              metal: item.metal || "",
              purity: item.purity || "",
              purityPercentage: item.purity_percentage || "",
              hsn_code: item.hsn_code || "",
              gross: parseFloat(item.gross) || 0,
              dust: parseFloat(item.dust) || 0,
              ml_percent: parseFloat(item.ml_percent) || 0,
              net_wt: parseFloat(item.net_wt) || 0,
              remarks: item.remarks || "",
              rate: parseFloat(item.rate) || 0,
              total_amount: parseFloat(item.total_amount) || 0,
              total_old_amount: response.data.reduce(
                (sum, i) => sum + parseFloat(i.total_amount || 0),
                0
              ),
            }));

            setOldSalesData(mappedOldItems);
            setOldTableData(mappedOldItems);
            localStorage.setItem(
              `oldTableData`,
              JSON.stringify(mappedOldItems)
            );
            
          } else {
            setOldSalesData([]);
            setOldTableData([]);
            localStorage.setItem(`oldTableData`, JSON.stringify([]));
          }
        } catch (error) {
          console.error("Error fetching old items:", error);
          setOldSalesData([]);
          setOldTableData([]);
        }
      }
    };

    fetchOldItemsForEstimate();
  }, [formData.estimate_number]);

  const schemeAmount = location.state?.scheme_amt
    ? parseFloat(location.state.scheme_amt)
    : schemeSalesData.reduce(
        (sum, item) => sum + parseFloat(item.paid_amount || 0),
        0
      );

  const [selectedRows, setSelectedRows] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [salesReturnData, setSalesReturnData] = useState([]);

  const handleCheckboxChange = (event, index) => {
    if (!invoiceDetails.length) return;

    const isChecked = event.target.checked;
    let updatedSelectedRows = isChecked
      ? [...selectedRows, index]
      : selectedRows.filter((i) => i !== index);

    setSelectedRows(updatedSelectedRows);
    setIsAllSelected(updatedSelectedRows.length === invoiceDetails.length);
  };

  const handleSelectAllChange = (event) => {
    if (!invoiceDetails.length) return;

    const isChecked = event.target.checked;
    setSelectedRows(isChecked ? invoiceDetails.map((_, index) => index) : []);
    setIsAllSelected(isChecked);
  };

  const handleCheckout = async () => {
    if (!invoiceDetails.length || !selectedRows.length) {
      // alert("No invoices selected for sale return.");
      return;
    }

    try {
      const selectedInvoices = selectedRows.map(
        (rowIndex) => invoiceDetails[rowIndex]
      );

      const repairDetailsUpdates = selectedInvoices.map((invoice) => ({
        id: invoice.id,
        status: "Sale Returned",
      }));

      const openTagsUpdates = selectedInvoices.map((invoice) => ({
        PCode_BarCode: invoice.code,
        Status: "Sale Returned",
      }));

      const productUpdates = selectedInvoices.map((invoice) => ({
        product_id: invoice.product_id,
        qty: invoice.qty,
        gross_weight: invoice.gross_weight,
      }));

      const codesForAvailableEntries = selectedInvoices.map(
        (invoice) => invoice.code
      );

      // Execute all API calls in parallel
      const responses = await Promise.allSettled([
        axios.post(`${baseURL}/updateRepairDetails`, {
          updates: repairDetailsUpdates,
        }),
        axios.post(`${baseURL}/updateOpenTags`, { updates: openTagsUpdates }),
        axios.post(`${baseURL}/updateProduct`, { updates: productUpdates }),
        axios.post(`${baseURL}/addAvailableEntry`, {
          codes: codesForAvailableEntries,
        }),
      ]);

      // Check if any API failed
      const failedRequests = responses.filter(
        (res) => res.status === "rejected"
      );
      if (failedRequests.length > 0) {
        console.error("Some API calls failed:", failedRequests);
        alert("Some updates failed. Please check console for details.");
      } else {
        alert("Sale Return added Successfully!");
      }
    } catch (error) {
      console.error("Error during checkout:", error);
      alert("An error occurred during checkout. Please try again.");
    }
  };

  useEffect(() => {
    const stored = localStorage.getItem(`repairDetails`);
    if (stored) {
      setRepairDetails(JSON.parse(stored));
    }
  }, []);

  const salesTaxableAmount = selectedRows.reduce((sum, rowIndex) => {
    const detail = invoiceDetails[rowIndex];
    const stonePrice = parseFloat(detail.stone_price) || 0;
    const makingCharges = parseFloat(detail.making_charges) || 0;
    const rateAmt = parseFloat(detail.rate_amt) || 0;
    const itemDiscount = parseFloat(detail.disscount) || 0;
    const itemFestivalDiscount = parseFloat(detail.festival_discount) || 0;
    return (
      sum +
      stonePrice +
      makingCharges +
      rateAmt -
      itemDiscount -
      itemFestivalDiscount
    );
  }, 0);

  const salesTaxAmount = selectedRows.reduce((sum, rowIndex) => {
    const detail = invoiceDetails[rowIndex];
    return sum + parseFloat(detail.tax_amt || 0);
  }, 0);

  const salesNetAmount = salesTaxableAmount + salesTaxAmount;

  // Calculate total sales return amount
  // For new sales returns (when items are selected), use the current UI selections
  // For existing sales returns (when no items are selected), use the saved data
  const totalSalesReturnAmount = selectedRows.length > 0 
    ? salesNetAmount  // Use current selection for new sales returns
    : (salesReturnData && salesReturnData.length > 0 
        ? salesReturnData.reduce((sum, item) => sum + parseFloat(item.total_price || 0), 0)
        : 0);  // No sales return data

  const isSameMonth = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    return (
      date.getMonth() === now.getMonth() &&
      date.getFullYear() === now.getFullYear()
    );
  };

  const allSelectedRowsAreThisMonth = selectedRows.every((rowIndex) =>
    isSameMonth(invoiceDetails[rowIndex]?.date)
  );

  const salesAmountToPass = allSelectedRowsAreThisMonth
    ? salesNetAmount
    : salesTaxableAmount;

  let totalAmount = 0;
  let discountAmt = 0;
  let festivalDiscountAmt = 0;
  let taxableAmount = 0;
  let taxAmount = 0;
  let netAmount = 0;
  let discountPercent = 0;
  let totalMakingCharges = 0;
  let totalPieceCost = 0;
  let hasWeightBasedItems = false;

  if (
    isManualNetMode &&
    typeof manualNetAmount !== "undefined" &&
    manualNetAmount > 0
  ) {
    // Step 1: Compute totalAmount, makingCharges, pieceCost

    repairDetails.forEach((item) => {
      if (!item) return; // Skip if item is undefined
      
      const pricing = item.pricing;

      if (pricing === "By Weight") {
        const stonePrice = parseFloat(item.stone_price) || 0;
        const makingCharges = parseFloat(item.making_charges) || 0;
        const rateAmt = parseFloat(item.rate_amt) || 0;
        const hmCharges = parseFloat(item.hm_charges) || 0;
        totalAmount += stonePrice + makingCharges + rateAmt + hmCharges;
        totalMakingCharges += makingCharges;
        hasWeightBasedItems = true;
      } else {
        const pieceCost = parseFloat(item.pieace_cost) || 0;
        const qty = parseFloat(item.qty) || 0;
        const itemTotal = pieceCost * qty;
        totalAmount += itemTotal;
        totalPieceCost += itemTotal;
      }
    });

    // Step 2: Reverse tax and discount calculation from netAmount
    let cumulativeTaxable = 0;
    let cumulativeTax = 0;
    let totalFestivalDiscount = 0;

    repairDetails.forEach((item) => {
      if (!item) return; // Skip if item is undefined
      
      const pricing = item.pricing;
      const itemTaxPercent = parseFloat(item.tax_percent) || 0;
      const itemFestivalDiscount = parseFloat(item.festival_discount) || 0;
      totalFestivalDiscount += itemFestivalDiscount;

      let itemTotal = 0;
      if (pricing === "By Weight") {
        const stonePrice = parseFloat(item.stone_price) || 0;
        const makingCharges = parseFloat(item.making_charges) || 0;
        const rateAmt = parseFloat(item.rate_amt) || 0;
        const hmCharges = parseFloat(item.hm_charges) || 0;
        itemTotal = stonePrice + makingCharges + rateAmt + hmCharges;
      } else {
        const pieceCost = parseFloat(item.pieace_cost) || 0;
        const qty = parseFloat(item.qty) || 0;
        itemTotal = pieceCost * qty;
      }

      const itemShare = itemTotal / totalAmount;
      const itemNet = manualNetAmount * itemShare;
      const itemTaxable = itemNet / (1 + itemTaxPercent / 100);
      const itemTax = itemNet - itemTaxable;

      cumulativeTaxable += itemTaxable;
      cumulativeTax += itemTax;
    });

    taxableAmount = cumulativeTaxable;
    taxAmount = cumulativeTax;
    netAmount = manualNetAmount;
    festivalDiscountAmt = totalFestivalDiscount;

    discountAmt = totalAmount - taxableAmount - totalFestivalDiscount;

    const discountBase = totalMakingCharges + totalPieceCost;
    discountPercent = discountBase ? (discountAmt * 100) / discountBase : 0;

    const roundedDiscount = parseFloat(discountPercent.toFixed(2));

    if (roundedDiscount !== discount) {
      setDiscount(roundedDiscount);
      localStorage.setItem(`discount`, roundedDiscount.toString());
      applyDiscountToRepairDetails(roundedDiscount);
    }
  } else {
    // FORWARD CALCULATION
    repairDetails.forEach((item) => {
      if (!item) return; // Skip if item is undefined
      
      const pricing = item.pricing;
      const itemDiscount = parseFloat(item.disscount) || 0;
      const itemFestivalDiscount = parseFloat(item.festival_discount) || 0;
      const itemTaxPercent = parseFloat(item.tax_percent) || 0;

      let itemTotal = 0;
      if (pricing === "By Weight") {
        const stonePrice = parseFloat(item.stone_price) || 0;
        const makingCharges = parseFloat(item.making_charges) || 0;
        const rateAmt = parseFloat(item.rate_amt) || 0;
        const hmCharges = parseFloat(item.hm_charges) || 0;

        itemTotal = stonePrice + makingCharges + rateAmt + hmCharges;
        totalAmount += itemTotal;
        totalMakingCharges += makingCharges;
        hasWeightBasedItems = true;
      } else {
        const pieceCost = parseFloat(item.pieace_cost) || 0;
        const qty = parseFloat(item.qty) || 0;

        itemTotal = pieceCost * qty;
        totalAmount += itemTotal;
        totalPieceCost += itemTotal;
      }

      const totalDiscount = itemDiscount + itemFestivalDiscount;
      const itemTaxable = itemTotal - totalDiscount;
      const taxAmt = (itemTaxable * itemTaxPercent) / 100;

      discountAmt += itemDiscount;
      festivalDiscountAmt += itemFestivalDiscount;

      taxableAmount += itemTaxable;
      taxAmount += taxAmt;
      netAmount += itemTaxable + taxAmt;
    });

    const discountBase = totalMakingCharges + totalPieceCost;
    discountPercent = discountBase ? (discountAmt * 100) / discountBase : 0;
  }

  const handleManualNetAmountChange = (value) => {
    setManualNetAmount(value);
    setIsManualNetMode(true); // Enter manual net amount mode
  };

  const handleManualNetPayAmountChange = (value) => {
    setManualNetPayAmount(value);
    setIsManualNetMode(true);

    // Calculate total amount without any discounts
    let totalAmountWithoutDiscounts = 0;
    let totalMakingCharges = 0;
    let totalPieceCost = 0;

    repairDetails.forEach((item) => {
      if (!item) return; // Skip if item is undefined
      
      const pricing = item.pricing;
      const itemFestivalDiscount = parseFloat(item.festival_discount) || 0;

      if (pricing === "By Weight") {
        const stonePrice = parseFloat(item.stone_price) || 0;
        const makingCharges = parseFloat(item.making_charges) || 0;
        const rateAmt = parseFloat(item.rate_amt) || 0;
        const hmCharges = parseFloat(item.hm_charges) || 0;
        totalAmountWithoutDiscounts +=
          stonePrice + makingCharges + rateAmt + hmCharges;
        totalMakingCharges += makingCharges;
      } else {
        const pieceCost = parseFloat(item.pieace_cost) || 0;
        const qty = parseFloat(item.qty) || 0;
        const itemTotal = pieceCost * qty;
        totalAmountWithoutDiscounts += itemTotal;
        totalPieceCost += itemTotal;
      }
    });

    // Calculate what the netAmount should be to achieve this netPayAmount
    const calculatedNetAmount =
      value + schemeAmount + oldItemsAmount - totalSalesReturnAmount;

    // Calculate the required taxable amount after preserving festival discount
    let totalTaxableAmount = 0;
    let totalTaxAmount = 0;

    repairDetails.forEach((item) => {
      if (!item) return; // Skip if item is undefined
      
      const pricing = item.pricing;
      const itemTaxPercent = parseFloat(item.tax_percent) || 0;
      const itemFestivalDiscount = parseFloat(item.festival_discount) || 0;

      let itemTotal = 0;
      if (pricing === "By Weight") {
        const stonePrice = parseFloat(item.stone_price) || 0;
        const makingCharges = parseFloat(item.making_charges) || 0;
        const rateAmt = parseFloat(item.rate_amt) || 0;
        const hmCharges = parseFloat(item.hm_charges) || 0;
        itemTotal = stonePrice + makingCharges + rateAmt + hmCharges;
      } else {
        const pieceCost = parseFloat(item.pieace_cost) || 0;
        const qty = parseFloat(item.qty) || 0;
        itemTotal = pieceCost * qty;
      }

      // Calculate item's share of the total amount
      const itemShare = itemTotal / totalAmountWithoutDiscounts;

      // Calculate item's net amount based on the calculatedNetAmount
      const itemNet = calculatedNetAmount * itemShare;

      // Calculate taxable amount after subtracting festival discount
      const itemTaxableBeforeFestival = itemNet / (1 + itemTaxPercent / 100);
      const itemTaxable = Math.max(
        0,
        itemTaxableBeforeFestival - itemFestivalDiscount
      );
      const itemTax = itemTaxable * (itemTaxPercent / 100);

      totalTaxableAmount += itemTaxable;
      totalTaxAmount += itemTax;
    });

    // Now calculate the required discount amount (excluding festival discount)
    const totalAfterFestivalDiscount =
      totalAmountWithoutDiscounts - festivalDiscountAmt;
    const requiredDiscountAmount =
      totalAfterFestivalDiscount - totalTaxableAmount;

    // Calculate discount percentage based on making charges and piece cost only
    const discountBase = totalMakingCharges + totalPieceCost;
    const discountPercent = discountBase
      ? (requiredDiscountAmount * 100) / discountBase
      : 0;

    const roundedDiscount = parseFloat(discountPercent.toFixed(2));

    if (roundedDiscount !== discount) {
      setDiscount(roundedDiscount);
      localStorage.setItem(`discount`, roundedDiscount.toString());
      applyDiscountToRepairDetails(roundedDiscount, true); // Pass true to preserve festival discount
    }

    setManualNetAmount(calculatedNetAmount);
  };

  // Update the payableAmount calculation
  const payableAmount = isManualNetMode
    ? manualNetPayAmount
    : netAmount -
      (schemeAmount + oldItemsAmount + totalSalesReturnAmount + totalAdvanceAmount);

  const netPayableAmount = payableAmount;
  
  // Debug logging for sales return calculations
  console.log("Sales Return Debug:", {
    salesNetAmount,
    totalSalesReturnAmount,
    netAmount,
    schemeAmount,
    oldItemsAmount,
    totalAdvanceAmount,
    payableAmount,
    netPayableAmount,
    selectedRows: selectedRows.length
  });
  // const updatedOldItemsAmount = oldItemsAmount + salesNetAmount;
  const netPayAmount = netPayableAmount;

  const [paymentDetails, setPaymentDetails] = useState({
    cash_amount: "", // Fix to two decimal places
    card_amt: "",
    chq_amt: "",
    online_amt: "",
  });

  // Save payment details to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem(
      `paymentDetails`,
      JSON.stringify(paymentDetails)
    );
  }, [paymentDetails]);

  useEffect(() => {
    // Retrieve payment details from localStorage on component mount
    const storedPaymentDetails = localStorage.getItem(
      `paymentDetails`
    );
    if (storedPaymentDetails) {
      setPaymentDetails(JSON.parse(storedPaymentDetails));
    }
  }, []);

  const clearData = () => {
    setOldSalesData([]);
    setSchemeSalesData([]);
    setRepairDetails([]);
    setPaymentDetails({
      cash_amount: 0,
      card_amt: 0,
      chq: "",
      chq_amt: 0,
      online: "",
      online_amt: 0,
    });
    setOldTableData([]); // Clear the oldTableData state
    setSchemeTableData([]);
    setDiscount(0);
    localStorage.removeItem("oldSalesData");
    localStorage.removeItem("schemeSalesData");
    localStorage.removeItem(`repairDetails`);
    localStorage.removeItem(`paymentDetails`);
    localStorage.removeItem(`oldTableData`);
    localStorage.removeItem(`schemeTableData`);
    localStorage.removeItem(`discount`);
    localStorage.removeItem(`saleFormData`);
    console.log("Data cleared successfully");
  };

  const handleSave = async (page = "sales") => {
    setSaving(true);
    try {
      // 🔍 1. Validate repair details
      if (!repairDetails.length) {
        alert("No repair details – nothing to save");
        return;
      }

      // 🟢 2. Build the estimate payload
      const estimatePayload = {
        estimate_number: formData.estimate_number,
        round_off: +(Math.round(netAmount) - netAmount).toFixed(2),
        online_amt: Number(paymentDetails.online_amt || 0),
        card_amt: Number(paymentDetails.card_amt || 0),
        cheque_amt: Number(paymentDetails.chq_amt || 0),
        cash_amt: Number(paymentDetails.cash_amount || 0),
        date: formData.date,
        total_amt: Number(totalAmount || 0),
        discount_amt: Number(discountAmt || 0),
        fest_discount_amt: Number(festivalDiscountAmt || 0),
        taxable_amt: Number(taxableAmount || 0),
        tax_amt: Number(taxAmount || 0),
        net_amt: Number(netAmount || 0),
        old_items_amt: Number(oldItemsAmount || 0),
        scheme_amt: Number(schemeAmount || 0),
        sale_return_amt: Number(totalSalesReturnAmount || 0),
        net_payable_amt: Number(netPayableAmount || 0),
      };

      if (formData.customer_id !== "") {
        estimatePayload.account_id = formData.customer_id;
      }

      // 📝 3. Update or create estimate
      let estimate_id;

      // First, check if an estimate with this number already exists
      try {
        const existingEstimateResponse = await axios.get(
          `${baseURL}/Estimate/estimate/${formData.estimate_number}`
        );
        
        if (existingEstimateResponse.data && existingEstimateResponse.data.id) {
          // Estimate exists, update it
          console.log("🔁 Updating existing estimate:", formData.estimate_number);
          console.log("🔁 Estimate payload being sent:", estimatePayload);
          
          estimate_id = existingEstimateResponse.data.id;
        const updateResponse = await axios.put(
          `${baseURL}/Estimate/update/${formData.estimate_number}`,
          estimatePayload
        );
        console.log("Update response:", updateResponse.data);
      } else {
          // Estimate doesn't exist, create new one
          throw new Error("Estimate not found");
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          // Estimate doesn't exist, create new one
          console.log("🆕 Creating new estimate with number:", formData.estimate_number);

        const estimateRes = await axios.post(
          `${baseURL}/Estimate/create`,
          estimatePayload
        );
        estimate_id = estimateRes.data.estimate_id;
          console.log("Create response:", estimateRes.data);
        } else {
          // Some other error occurred
          console.error("Error checking/creating estimate:", error);
          throw error;
        }
      }

      // 🧾 4. Save or update products
      for (const item of repairDetails) {
        const productPayload = {
          id: item.id,
          barcode: item.code,
          estimate_number: formData.estimate_number,
          product_name: item.product_name,
          metal: item.metal_type,
          purity: item.purity,
          gr_wt: item.gross_weight,
          st_wt: item.stone_weight,
          va_perc: item.va_percent,
          total_wt: item.total_weight_av,
          rate: item.rate,
          mc: item.making_charges,
          discount: item.disscount,
          fest_discount: item.festival_discount,
          tax_perc: item.tax_percent,
          tax_amt: item.tax_amt,
          total_price: item.total_price,
          image: item.imagePreview,
          status: item.transaction_status,
          category: item.category,
          sub_category: item.product_name,
          design_name: item.design_name,
          product_status: item.estimate_status,
          estimate_id, // may be needed for new ones
        };

        if (item.id) {
          // Product has an ID, try to update it
          console.log("Updating existing product:", item.id);
          try {
          await axios.put(
            `${baseURL}/Product/update/${item.id}`,
            productPayload
          );
          } catch (error) {
            console.error("Error updating product:", error);
            // If update fails, try to create new one
            console.log("Update failed, creating new product");
            await axios.post(`${baseURL}/Product/create-product`, productPayload);
          }
        } else {
          // Product doesn't have an ID, create new one
          console.log("Creating new product");
          await axios.post(`${baseURL}/Product/create-product`, productPayload);
        }
      }

      // 🗑️ 5. Handle old items (URD Purchase items) - Delete existing ones first if estimate exists
      try {
        // Get existing old items for this estimate
        const existingOldItemsResponse = await axios.get(
          `${baseURL}/get/olditems/${formData.estimate_number}`
        );
        
        if (existingOldItemsResponse.data && existingOldItemsResponse.data.length > 0) {
          console.log("Deleting existing old items:", existingOldItemsResponse.data);
          
          // Delete each existing old item
          for (const existingItem of existingOldItemsResponse.data) {
            if (existingItem.id) {
              await axios.delete(`${baseURL}/delete/olditems/${existingItem.id}`);
              console.log("Deleted existing old item:", existingItem.id);
            }
          }
        }
      } catch (error) {
        console.error("Error deleting existing old items:", error);
        // Continue with saving new items even if deletion fails
      }

      // 💾 6. Save new old items (URD Purchase items)
      if (oldSalesData && oldSalesData.length > 0) {
        console.log("Saving URD Purchase items:", oldSalesData);
        for (const item of oldSalesData) {
          const urdPurchasePayload = {
            estimate_number: formData.estimate_number,
            estimate_id: estimate_id,
            product_name: item.product,
            metal: item.metal,
            purity: item.purity,
            purity_percentage: item.purityPercentage || "",
            hsn_code: item.hsn_code || "",
            gross: parseFloat(item.gross) || 0,
            dust: parseFloat(item.dust) || 0,
            ml_percent: parseFloat(item.ml_percent) || 0,
            net_wt: parseFloat(item.net_wt) || 0,
            remarks: item.remarks || "",
            rate: parseFloat(item.rate) || 0,
            total_amount: parseFloat(item.total_amount) || 0,
            status: "URD Purchase",
            transaction_type: "estimate_urd_purchase",
          };

          try {
            await axios.post(
              `${baseURL}/save-urd-purchase-item`,
              urdPurchasePayload
            );
            console.log("URD Purchase item saved:", urdPurchasePayload);
          } catch (error) {
            console.error("Error saving URD purchase item:", error);
          }
        }
      }

      // 🔄 7. Handle sales return items - Check existing ones
      try {
        // Get existing sales return items for this estimate
        const response = await axios.get(`${baseURL}/get/repair-details`);
        if (response.data) {
          const existingSalesReturns = response.data.filter(item => 
            item.estimate_number === formData.estimate_number && 
            item.status === "Sale Returned"
          );
          
          if (existingSalesReturns.length > 0) {
            console.log("Found existing sales return items:", existingSalesReturns);
            // Note: We don't delete existing sales returns as they are part of the repair details
            // They will be updated if needed through the normal sales return process
          }
        }
      } catch (error) {
        console.error("Error checking existing sales return items:", error);
      }

      // 💾 8. Save new sales return items using estimate sales return endpoint
      if (selectedRows.length > 0 && invoiceDetails.length > 0) {
        console.log("Processing sales return items:", selectedRows);
        const selectedInvoices = selectedRows.map(
          (rowIndex) => invoiceDetails[rowIndex]
        );

        for (const invoice of selectedInvoices) {
          const salesReturnPayload = {
            estimate_number: formData.estimate_number,
            original_invoice_number: invoice.invoice_number || "",
            product_name: invoice.product_name || "",
            metal: invoice.metal_type || "",
            purity: invoice.purity || "",
            gross_weight: parseFloat(invoice.gross_weight) || 0,
            stone_weight: parseFloat(invoice.stone_weight) || 0,
            rate: parseFloat(invoice.rate) || 0,
            rate_amt: parseFloat(invoice.rate_amt) || 0,
            making_charges: parseFloat(invoice.making_charges) || 0,
            stone_price: parseFloat(invoice.stone_price) || 0,
            hm_charges: parseFloat(invoice.hm_charges) || 0,
            disscount: parseFloat(invoice.disscount) || 0,
            festival_discount: parseFloat(invoice.festival_discount) || 0,
            tax_percent: parseFloat(invoice.tax_percent) || 0,
            tax_amt: parseFloat(invoice.tax_amt) || 0,
            total_price: parseFloat(invoice.total_price) || 0,
            qty: parseFloat(invoice.qty) || 1,
            status: "Estimate Sale Returned",
            transaction_type: "estimate_sale_return",
            return_date: formData.date,
            remarks: invoice.remarks || "",
            category: invoice.category || "",
            sub_category: invoice.sub_category || "",
            design_name: invoice.design_name || "",
            code: invoice.code || "",
            customer_id: formData.customer_id || "",
            customer_name: formData.account_name || "",
          };

          try {
            await axios.post(
              `${baseURL}/save-estimate-sale-return-item`,
              salesReturnPayload
            );
            console.log("Sales return item saved:", salesReturnPayload);
          } catch (error) {
            console.error("Error saving sales return item:", error);
          }
        }
      }

      alert(
        "Estimate saved successfully"
      );

      setSaving(false);
      if (Mode !== "edit") resetForm();
      clearData();
      // Trigger PDF print programmatically
      const blob = await new Promise((resolve) => {
        // Simulate getting blob from BlobProvider (you may need to adjust this)
        const provider = document
          .querySelector("#download-estimate-pdf")
          .closest("BlobProvider");
        provider?.addEventListener("blob", (e) => resolve(e.detail.blob), {
          once: true,
        });
        document.getElementById("download-estimate-pdf").click();
      });

      if (blob) {
        const blobUrl = URL.createObjectURL(blob);
        const newWindow = window.open(blobUrl, "_blank");
        if (newWindow) {
          newWindow.onload = () => {
            newWindow.focus();
            newWindow.print();
          };
          setTimeout(() => {
            newWindow.focus();
            newWindow.print();
          }, 1000);
        } else {
          alert("Please allow pop-ups to view and print the PDF.");
        }
      }
      window.location.reload();
    } catch (error) {
      console.error("❌ Error saving data:", error);
      alert("Something went wrong while saving. See console for details.");
    } finally {
      setSaving(false);
      window.location.reload(); // Move reload to after print if possible
    }
  };

  /* const handleSavePDFToServer = async (pdfBlob, invoiceNumber) => {
    const formData = new FormData();
    formData.append("invoice", pdfBlob, `${invoiceNumber}.pdf`);

    try {
      const response = await fetch(`${baseURL}/upload-invoice`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to upload invoice");
      }

      console.log(`Invoice ${invoiceNumber} saved on server`);
    } catch (error) {
      console.error("Error uploading invoice:", error);
    }
  }; */

  const refreshSalesData = () => {
    setOldSalesData([]);
    setSchemeSalesData([]);
    setRepairDetails([]);
    setPaymentDetails({
      cash_amount: 0,
      card_amt: 0,
      chq: "",
      chq_amt: 0,
      online: "",
      online_amt: 0,
    });
    setOldTableData([]); // Clear the oldTableData state
    setSchemeTableData([]);
    setDiscount(0);
    localStorage.removeItem("oldSalesData");
    localStorage.removeItem("schemeSalesData");
    localStorage.removeItem(`repairDetails`);
    localStorage.removeItem(`paymentDetails`);
    localStorage.removeItem(`oldTableData`);
    localStorage.removeItem(`schemeTableData`);
    localStorage.removeItem(`discount`);
    
    window.location.reload();
  };

  const mobileRef = useRef(null); // Reference to Mobile input field in CustomerDetails

  useEffect(() => {

  }, [formData.estimate_number]); //marre

  useEffect(() => {
    if (formData.code) {
      mobileRef.current?.focus(); // Move focus to Mobile when BarCode is entered
    }
  }, [formData.code]);

  // Apply calculations
  useCalculations(
    formData,
    setFormData,
    offers,
    isManualTotalPriceChange,
    setIsManualTotalPriceChange,
    isTotalPriceCleared
  );

  useEffect(() => {
    const incomingOrderDetails = location.state?.orderDetails;
    if (incomingOrderDetails && incomingOrderDetails.length > 0) {
      const item = incomingOrderDetails[0];
      setFormData((prev) => ({
        ...prev,
        // Customer fields
        customer_id: item.customer_id ?? "",
        account_name: item.account_name ?? "",
        mobile: item.mobile ?? "",
        email: item.email ?? "",
        address1: item.address1 ?? "",
        address2: item.address2 ?? "",
        city: item.city ?? "",
        pincode: item.pincode ?? "",
        state: item.state ?? "",
        state_code: item.state_code ?? "",
        aadhar_card: item.aadhar_card ?? "",
        gst_in: item.gst_in ?? "",
        pan_card: item.pan_card ?? "",
        // Product fields
        category: item.category ?? "",
        code: item.code ?? "",
        metal_type: item.metal_type ?? "",
        product_name: item.product_name ?? "",
        design_name: item.design_name ?? "",
        pricing: item.pricing ?? "",
        purity: item.purity ?? "",
        gross_weight: item.gross_weight ?? "",
        stone_weight: item.stone_weight ?? "",
        stone_price: item.stone_price ?? "",
        weight_bw: item.weight_bw ?? "",
        va_on: item.va_on ?? "",
        va_percent: item.va_percent ?? "",
        wastage_weight: item.wastage_weight ?? "",
        total_weight_av: item.total_weight_av ?? "",
        size: item.size ?? "",
        rate: item.rate ?? "",
        rate_amt: item.rate_amt ?? "",
        mc_on: item.mc_on ?? "",
        mc_per_gram: item.mc_per_gram ?? "",
        making_charges: item.making_charges ?? "",
        hm_charges: item.hm_charges ?? "",
        tax_percent: item.tax_percent ?? "",
        tax_amt: item.tax_amt ?? "",
        total_price: item.total_price ?? "",
        remarks: item.remarks ?? "",
        qty: item.qty ?? "",
        imagePreview: item.imagePreview ?? "",
        // ...add any other fields your form expects
      }));
    }
  }, [location.state]);

  useEffect(() => {
    // Check if this is a new estimate from dashboard
    const isNewEstimate = location.state?.isNewEstimate;

    if (isNewEstimate) {

      const dashboardMobile = location.state?.mobile;

      // Set mode to create for new estimate
      setMode("create");

      // Clear all form data for new estimate
      setFormData((prev) => ({
        ...prev,
        customer_id: "",
        account_name: "",
        mobile: dashboardMobile || "",
        email: "",
        address1: "",
        address2: "",
        city: "",
        pincode: "",
        state: "",
        state_code: "",
        aadhar_card: "",
        gst_in: "",
        pan_card: "",
        date: new Date().toISOString().split("T")[0],
        estimate_number: "", // Will trigger auto-generation
      }));

      // Clear payment details
      setPaymentDetails({
        cash_amount: 0,
        card_amt: 0,
        chq_amt: 0,
        online_amt: 0,
      });

      // Clear products
      setRepairDetails([]);
      localStorage.removeItem(`repairDetails`);
      localStorage.removeItem(`paymentDetails`);

      // If mobile number is provided, populate customer details
      if (dashboardMobile && customers.length > 0) {
        const customer = customers.find(
          (cust) => cust.mobile === dashboardMobile
        );
        if (customer) {
  
          setFormData((prev) => ({
            ...prev,
            customer_id: customer.account_id || "",
            account_name: customer.account_name || "",
            mobile: customer.mobile || "",
            email: customer.email || "",
            address1: customer.address1 || "",
            address2: customer.address2 || "",
            city: customer.city || "",
            pincode: customer.pincode || "",
            state: customer.state || "",
            state_code: customer.state_code || "",
            aadhar_card: customer.aadhar_card || "",
            gst_in: customer.gst_in || "",
            pan_card: customer.pan_card || "",
          }));
          setSelectedMobile(customer.mobile || "");
        }
      }

      return; // Exit early for new estimates
    }

    if (estimateData) {
      

      // Set mode to edit since we're loading existing data
      setMode("edit");

      // Set header fields with proper mapping
      setFormData((prev) => ({
        ...prev,
        // Estimate header fields
        estimate_number: estimateData.estimate?.estimate_number || "",
        date: estimateData.estimate?.date
          ? new Date(estimateData.estimate.date).toISOString().split("T")[0]
          : new Date().toISOString().split("T")[0],
        // Account/Customer fields - handle null account gracefully
        customer_id: estimateData.account?.account_id || "",
        account_name: estimateData.account?.account_name || "",
        mobile:
          estimateData.account?.phone || estimateData.account?.mobile || "",
        email: estimateData.account?.email || "",
        address1: estimateData.account?.address1 || "",
        address2: estimateData.account?.address2 || "",
        city: estimateData.account?.city || "",
        pincode: estimateData.account?.pincode || "",
        state: estimateData.account?.state || "",
        state_code: estimateData.account?.state_code || "",
        aadhar_card: estimateData.account?.aadhar_card || "",
        gst_in: estimateData.account?.gst_in || "",
        pan_card: estimateData.account?.pan_card || "",
      }));

      // Set payment details from estimate data - ensure they are numbers
      setPaymentDetails({
        cash_amount: Number(estimateData.estimate?.cash_amt || 0),
        card_amt: Number(estimateData.estimate?.card_amt || 0),
        chq_amt: Number(estimateData.estimate?.cheque_amt || 0),
        online_amt: Number(estimateData.estimate?.online_amt || 0),
      });

      // Map products with proper field mapping
      if (estimateData.products && estimateData.products.length > 0) {
        const mappedProducts = estimateData.products.map((product) => {
          // Calculate derived fields
          const grossWeight = parseFloat(product.gr_wt) || 0;
          const stoneWeight = parseFloat(product.st_wt) || 0;
          const weightBW = grossWeight - stoneWeight;
          const vaPercent = parseFloat(product.va_perc) || 0;
          const wastageWeight = (grossWeight * vaPercent) / 100;
          const totalWeightAV = weightBW + wastageWeight;
          const rate = parseFloat(product.rate) || 0;
          const rateAmt = rate * totalWeightAV;
          const stonePrice = parseFloat(product.stone_price) || 0;
          const makingCharges = parseFloat(product.mc) || 0;
          const hmCharges = parseFloat(product.hm_charges) || 60; // Default HM charges
          const discount = parseFloat(product.discount) || 0;
          const festivalDiscount = parseFloat(product.fest_discount) || 0;
          const taxPercent = parseFloat(product.tax_perc) || 3;

          // Calculate taxable amount and tax
          const totalBeforeTax =
            rateAmt +
            stonePrice +
            makingCharges +
            hmCharges -
            discount -
            festivalDiscount;
          const taxAmt = (totalBeforeTax * taxPercent) / 100;
          const totalPrice = totalBeforeTax + taxAmt;

          return {
            // Map backend fields to form fields
            id: product.id || "",
            code: product.barcode || "",
            product_name: product.product_name || "",
            metal_type: product.metal || "",
            purity: product.purity || "",
            gross_weight: grossWeight.toFixed(2),
            stone_weight: stoneWeight.toFixed(2),
            va_percent: vaPercent.toFixed(2),
            total_weight_av: totalWeightAV.toFixed(2),
            weight_bw: weightBW.toFixed(2),
            wastage_weight: wastageWeight.toFixed(2),
            rate: rate.toFixed(2),
            rate_amt: rateAmt.toFixed(2),
            making_charges: makingCharges.toFixed(2),
            stone_price: stonePrice.toFixed(2),
            hm_charges: hmCharges.toFixed(2),
            disscount: discount.toFixed(2),
            festival_discount: festivalDiscount.toFixed(2),
            tax_percent: `${taxPercent}% GST`,
            tax_amt: taxAmt.toFixed(2),
            total_price: totalPrice.toFixed(2),
            imagePreview: product.image || "",
            status: product.status || "active",
            remarks: product.remarks || "",
            remarks_type: product.remarks_type || "",
            qty: (product.qty || 1).toString(),
            // Add any other required fields with defaults
            category: product.category || "",
            sub_category: product.sub_category || "",
            design_name: product.design_name || "",
            va_on: "Gross Weight",
            mc_on: "MC %",
            mc_per_gram: "0",
            pricing: "By Weight",
            piece_taxable_amt: totalBeforeTax.toFixed(2),
            sale_status: "Not Delivered",
            estimate_status: "Not Delivered",
            transaction_status: "Sales",
            date:
              estimateData.estimate?.date ||
              new Date().toISOString().split("T")[0],
            estimate_number: estimateData.estimate?.estimate_number || "",
          };
        });

        setRepairDetails(mappedProducts);
        localStorage.setItem(
          `repairDetails`,
          JSON.stringify(mappedProducts)
        );
        

        // Set current index for navigation
        const idx = sortedEstimates.findIndex(
          (est) =>
            est.uniqueData.estimate_number ===
            estimateData.estimate?.estimate_number
        );
        console.log(
          "Setting current index:",
          idx,
          "for estimate:",
          estimateData.estimate?.estimate_number
        );
        console.log(
          "Available estimates in sortedEstimates:",
          sortedEstimates.map((e) => e.uniqueData.estimate_number)
        );
        setCurrentEstimateIndex(idx);
        setSelectedEstimate(estimateData.estimate?.estimate_number || "");
      }
    }
  }, [estimateData, sortedEstimates]);

  // Fetch existing sales return data for the current estimate
  const fetchSalesReturnData = async (estimateNumber) => {
    if (!estimateNumber) {
      setSalesReturnData([]);
      return;
    }

    try {
      // Use the estimate sales return endpoint
      const response = await axios.get(
        `${baseURL}/get-estimate-sale-returns/${estimateNumber}`
      );
      setSalesReturnData(response.data || []);
    } catch (error) {
      console.error("Error fetching sales return data:", error);
      setSalesReturnData([]);
    }
  };

  // Fetch sales return data when estimate number changes
  useEffect(() => {
    fetchSalesReturnData(formData.estimate_number);
  }, [formData.estimate_number]);

  // Recalculate amounts when sales return data changes
  useEffect(() => {
    // Force a re-render by updating a state that triggers calculations
    // This will ensure the payableAmount is recalculated with the new sales return data
  }, [salesReturnData]);

  // Recalculate amounts when selected rows change (UI selections)
  useEffect(() => {
    // Force a re-render by updating a state that triggers calculations
    // This will ensure the payableAmount is recalculated with the new sales return selections
  }, [selectedRows]);

  // Force re-render when netPayableAmount changes
  useEffect(() => {
  }, [netPayableAmount]);

  // Track when PDF data is ready
  useEffect(() => {
    const isDataReady = formData.estimate_number && 
                       repairDetails.length > 0 && 
                       totalAmount > 0 && 
                       netPayableAmount > 0;
    
    if (isDataReady) {
    } else {
    }
  }, [formData.estimate_number, repairDetails, totalAmount, netPayableAmount]);

  // Populate sales return UI with existing data
  useEffect(() => {
    if (salesReturnData && salesReturnData.length > 0) {
      // Get unique invoice numbers from sales return data
      const invoiceNumbers = [...new Set(salesReturnData.map(item => item.original_invoice_number))];
      
      if (invoiceNumbers.length > 0) {
        // Set the first invoice number as selected
        const selectedInvoiceNumber = invoiceNumbers[0];
        // Update return data to set the invoice number
        setReturnData(prev => ({
          ...prev,
          invoice_number: selectedInvoiceNumber
        }));
        
        // Update filtered invoices to include the invoice from sales return data
        const updateFilteredInvoices = async () => {
          try {
            // Get all unique invoices
            const response = await axios.get(`${baseURL}/get-unique-repair-details`);
            if (response.data) {
              const allInvoices = response.data.filter(item => item.transaction_status === "Sales");
              
              // Add the invoice from sales return data if it's not already in the list
              const salesReturnInvoices = invoiceNumbers.map(invoiceNumber => ({
                invoice_number: invoiceNumber,
                transaction_status: "Sales"
              }));
              
              const combinedInvoices = [...allInvoices];
              salesReturnInvoices.forEach(salesReturnInvoice => {
                if (!combinedInvoices.find(inv => inv.invoice_number === salesReturnInvoice.invoice_number)) {
                  combinedInvoices.push(salesReturnInvoice);
                }
              });
              
              setFilteredInvoices(combinedInvoices);
            }
          } catch (error) {
            console.error("Error updating filtered invoices:", error);
          }
        };
        
        updateFilteredInvoices();
        
        // Fetch invoice details for this invoice
        const fetchInvoiceDetailsForSalesReturn = async () => {
          try {
            const response = await axios.get(`${baseURL}/getsales/${selectedInvoiceNumber}`);
            if (response.data) {
              // Filter out items that are already returned
              const availableItems = response.data.filter(item => item.status !== "Sale Returned");
              setInvoiceDetails(availableItems);
              
              // Find which items from this invoice are in the sales return data
              const returnedItemCodes = salesReturnData
                .filter(item => item.original_invoice_number === selectedInvoiceNumber)
                .map(item => item.code);
              
              // Set selected rows based on returned items
              const selectedRowIndices = availableItems
                .map((item, index) => returnedItemCodes.includes(item.code) ? index : -1)
                .filter(index => index !== -1);
              
              console.log("Setting selected rows:", selectedRowIndices);
              setSelectedRows(selectedRowIndices);
              setIsAllSelected(selectedRowIndices.length === availableItems.length && availableItems.length > 0);
            }
          } catch (error) {
            console.error("Error fetching invoice details for sales return:", error);
          }
        };
        
        fetchInvoiceDetailsForSalesReturn();
      }
    }
  }, [salesReturnData]);

  return (
    <div className="main-container">
      <Container className="sales-form-container">
        <Form>
          {/* <h3 style={{ marginTop: '-45px', marginBottom: '10px', textAlign: 'left', color: '#a36e29' }}>
            Sales
          </h3> */}
          <div className="sales-form" style={{ marginTop: "-40px" }}>
            <div className="sales-form-left">
              <CustomerDetails
                formData={formData}
                setFormData={setFormData}
                handleCustomerChange={handleCustomerChange}
                handleAddCustomer={handleAddCustomer}
                customers={customers}
                setSelectedMobile={setSelectedMobile} // Pass the setSelectedMobile function here
                mobileRef={mobileRef}
                isEstimatePage={isEstimatePage} //marre
              />
            </div>
            <div className="sales-form-right">
              <EstimateDetails
                formData={formData}
                setFormData={setFormData}
                currentEstimateIndex={currentEstimateIndex}
                totalEstimates={sortedEstimates.length}
                onPrev={navigateToPreviousEstimate}
                onNext={navigateToNextEstimate}
                onFirst={navigateToFirstEstimate}
                onLast={navigateToLastEstimate}
              />
            </div>
          </div>
          <div
            className="sales-form-section"
            style={{ marginTop: "-20px", marginBottom: "5px" }}
          >
            <ProductDetails
              formData={formData}
              setFormData={setFormData}
              handleChange={handleChange}
              handleBarcodeChange={handleBarcodeChange}
              handleProductChange={handleProductChange}
              handleProductNameChange={handleProductNameChange}
              handleMetalTypeChange={handleMetalTypeChange}
              handleDesignNameChange={handleDesignNameChange}
              handleAdd={handleAdd}
              products={products}
              data={data}
              uniqueProducts={uniqueProducts}
              categoryOptions={categoryOptions}
              subcategoryOptions={subcategoryOptions}
              purityOptions={purityOptions}
              designOptions={designOptions}
              metaltypeOptions={metaltypeOptions}
              filteredMetalTypes={filteredMetalTypes}
              filteredPurityOptions={filteredPurityOptions}
              filteredDesignOptions={filteredDesignOptions}
              isBarcodeSelected={isBarcodeSelected}
              isQtyEditable={isQtyEditable}
              handleUpdate={handleUpdate}
              isEditing={editIndex !== null}
              handleImageChange={handleImageChange}
              image={image}
              fileInputRef={fileInputRef}
              clearImage={clearImage}
              captureImage={captureImage}
              setShowWebcam={setShowWebcam}
              showWebcam={showWebcam}
              webcamRef={webcamRef}
              setShowOptions={setShowOptions}
              showOptions={showOptions}
              estimate={estimate}
              selectedEstimate={selectedEstimate}
              handleEstimateChange={handleEstimateChange}
              refreshSalesData={refreshSalesData}
              fetchCategory={fetchCategory}
              fetchSubCategory={fetchSubCategory}
              taxableAmount={taxableAmount}
              offers={offers}
              isTotalPriceCleared={isTotalPriceCleared}
              setIsTotalPriceCleared={setIsTotalPriceCleared}
              isManualTotalPriceChange={isManualTotalPriceChange}
              setIsManualTotalPriceChange={setIsManualTotalPriceChange}
              manualTotalPriceRef={manualTotalPriceRef}
              handleOrderChange={handleOrderChange}
              selectedOrder={selectedOrder}
              orderData={orderData}
            />
          </div>

          <div className="sales-form-section">
            <ProductTable
              repairDetails={repairDetails}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          </div>

          <div className="sales-form">
            <div className="sales-form-third">
              <SalesFormSection
                metal={metal}
                setMetal={setMetal}
                setOldSalesData={setOldSalesData}
                oldTableData={oldTableData}
                setOldTableData={setOldTableData}
                setSchemeSalesData={setSchemeSalesData}
                schemeTableData={schemeTableData}
                setSchemeTableData={setSchemeTableData}
                filteredInvoices={filteredInvoices}
                setFilteredInvoices={setFilteredInvoices}
                uniqueInvoice={uniqueInvoice}
                setUniqueInvoice={setUniqueInvoice}
                invoiceDetails={invoiceDetails}
                saving={saving}
                setInvoiceDetails={setInvoiceDetails}
                handleInvoiceChange={handleInvoiceChange}
                returnData={returnData}
                setReturnData={setReturnData}
                selectedMobile={formData.mobile}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                isAllSelected={isAllSelected}
                setIsAllSelected={setIsAllSelected}
                handleCheckboxChange={handleCheckboxChange}
                handleSelectAllChange={handleSelectAllChange}
                salesTaxableAmount={salesTaxableAmount}
                salesTaxAmount={salesTaxAmount}
                salesNetAmount={salesNetAmount}
                repairDetails={repairDetails}
                resetSaleReturnForm={resetSaleReturnForm}
                handleCheckout={handleCheckout}
                setRepairDetails={setRepairDetails}
                formData={formData}
                orderData={orderData}
                handleCloseModal={handleCloseModal}
                handleViewDetails={handleViewDetails}
                selectedOrder={selectedOrder}
                handleOrderCheckboxChange={handleOrderCheckboxChange}
                showModal={showModal}
                orderDetails={orderDetails}
                loading={loading}
                formatDate={formatDate}
                repairs={repairs}
                handleRepairCheckboxChange={handleRepairCheckboxChange}
                salesReturnData={salesReturnData}
                estimateNumber={formData.estimate_number}
              />
            </div>
            <div className="sales-form-fourth">
              <PaymentDetails
                orderDetails={orderDetails}
                paymentDetails={paymentDetails}
                setPaymentDetails={setPaymentDetails}
                handleSave={handleSave}
                handleBack={handleBack}
                totalPrice={totalPrice}
                repairDetails={repairDetails}
                setRepairDetails={setRepairDetails}
                taxableAmount={taxableAmount}
                discountAmt={discountAmt}
                totalAmount={totalAmount}
                taxAmount={taxAmount}
                netAmount={netAmount}
                oldItemsAmount={oldItemsAmount}
                schemeAmount={schemeAmount}
                netPayableAmount={netPayableAmount}
                salesNetAmount={salesNetAmount}
                salesAmountToPass={salesAmountToPass}
                salesTaxableAmount={salesTaxableAmount}
                saving={saving}
                // updatedOldItemsAmount={updatedOldItemsAmount}
                netPayAmount={netPayAmount}
                oldSalesData={oldSalesData}
                schemeSalesData={schemeSalesData}
                discount={discount}
                handleDiscountChange={handleDiscountChange}
                refreshSalesData={refreshSalesData}
                setOffers={setOffers}
                offers={offers}
                loading={loading}
                festivalShowModal={festivalShowModal}
                // handleApply={handleApply}
                handleFestivalShowModal={handleFestivalShowModal}
                handleFestivalCloseModal={handleFestivalCloseModal}
                appliedOffers={appliedOffers}
                setAppliedOffers={setAppliedOffers}
                festivalDiscountAmt={festivalDiscountAmt}
                manualNetAmount={manualNetAmount}
                setManualNetAmount={setManualNetAmount}
                handleManualNetAmountChange={handleManualNetAmountChange}
                isManualNetMode={isManualNetMode}
                setIsManualNetMode={setIsManualNetMode}
                handleManualNetPayAmountChange={handleManualNetPayAmountChange}
                manualNetPayAmount={manualNetPayAmount}
                handleApply={handleApply}
                isAnyOfferApplied={isAnyOfferApplied}
                applyDiscountAmountToRepairDetails={
                  applyDiscountAmountToRepairDetails
                }
                estimate_number={formData.estimate_number}
              />
            </div>
          </div>
          {/* <PDFDownloadLink
            id="download-estimate-pdf"
            className=""
              document={
                <EstimateA4
                  formData={{
                    estimate: formData.estimate_number,
                    date: formData.date,
                    time: new Date().toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    }),
                    customerName: formData.account_name,
                    mobile: formData.mobile,
                  }}
                                  items={repairDetails.map((item) => {
                  if (!item) return null; // Skip if item is undefined
                  return {
                    categoty: `${item.category || ""}`,
                    item: `${item.product_name || ""} (${item.metal_type || ""})`,
                    rate: item.rate || 0,
                    weight: item.total_weight_av
                      ? `${item.total_weight_av} GM`
                      : "-",
                    mc: `${item.making_charges || ""}`,
                    value: item.total_price || 0,
                  };
                }).filter(Boolean)} // Remove null items
                  subtotal={totalAmount}
                  cgst={taxAmount / 2}
                  sgst={taxAmount / 2}
                  grandTotal={netPayableAmount}
                />
              }
              fileName={`Estimate-${formData.estimate_number}.pdf`}
            >
              {({ loading }) =>
                loading ? "Generating..." : "Download Estimate PDF"
              }
            </PDFDownloadLink> */}

          {/* Only render BlobProvider when data is ready */}
          {formData.estimate_number && repairDetails.length > 0 && totalAmount > 0 ? (
          <BlobProvider
            document={
              <EstimateA4
                formData={{
                    estimate: formData.estimate_number || "EST-000",
                    date: formData.date || new Date().toISOString().split("T")[0],
                  time: new Date().toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  }),
                    customerName: formData.account_name || "Customer",
                    mobile: formData.mobile || "",
                }}
                  items={repairDetails
                    .filter(item => item && item.product_name) // Filter out undefined/null items
                    .map((item) => ({
                      categoty: item.category || "",
                      item: `${item.product_name || ""} (${item.metal_type || ""})`,
                      rate: parseFloat(item.rate) || 0,
                  weight: item.total_weight_av
                        ? `${parseFloat(item.total_weight_av).toFixed(2)} GM`
                    : "-",
                      mc: parseFloat(item.making_charges) || 0,
                      value: parseFloat(item.total_price) || 0,
                }))}
                  subtotal={parseFloat(totalAmount) || 0}
                  cgst={parseFloat(taxAmount / 2) || 0}
                  sgst={parseFloat(taxAmount / 2) || 0}
                  grandTotal={parseFloat(netPayableAmount) || 0}
              />
            }
          >
            {({ blob, loading, error }) => {
              const handlePrintPDF = async () => {
                // Check if we're still loading
                if (loading) {
                  console.log("PDF is still loading, please wait...");
                  alert("PDF is still being generated. Please wait a moment and try again.");
                  return;
                }

                // Check for errors
                if (error) {
                  console.error("PDF generation error:", error);
                  alert("Failed to generate PDF. Please try again.");
                  return;
                }

                // Check if blob is available
                if (!blob) {
                  console.error("PDF blob is not available.");
                  alert("PDF is not ready yet. Please wait a moment and try again.");
                  return;
                }

                try {
                  // Create blob URL
                  const blobUrl = URL.createObjectURL(blob);
                  
                  // Try to open the window
                  const newWindow = window.open(blobUrl, "_blank", "width=800,height=600,scrollbars=yes,resizable=yes");

                  if (!newWindow) {
                    console.error("Failed to open new window. Pop-up blocked.");
                    alert("Pop-up was blocked. Please allow pop-ups for this site and try again.");
                    return;
                  }

                  // Wait for the window to load
                  const waitForWindowLoad = () => {
                    return new Promise((resolve, reject) => {
                      const checkWindow = () => {
                        if (newWindow.closed) {
                          reject(new Error("Window was closed"));
                          return;
                        }
                        
                        try {
                          // Check if the window is ready
                          if (newWindow.document.readyState === 'complete') {
                            resolve(newWindow);
                          } else {
                            setTimeout(checkWindow, 100);
                          }
                        } catch (e) {
                          // Cross-origin error, window might still be loading
                          setTimeout(checkWindow, 100);
                        }
                      };
                      
                      checkWindow();
                    });
                  };

                  // Wait for window to load, then print
                  try {
                    await waitForWindowLoad();
                    newWindow.focus();
                    
                    // Small delay to ensure PDF is fully rendered
                    setTimeout(() => {
                      newWindow.print();
                    }, 500);
                    
                  } catch (windowError) {
                    console.error("Error waiting for window to load:", windowError);
                    // Fallback: try to print anyway
                      newWindow.focus();
                    setTimeout(() => {
                      newWindow.print();
                    }, 1000);
                  }

                } catch (error) {
                  console.error("Error in handlePrintPDF:", error);
                  alert("Failed to open PDF. Please try again.");
                }
              };

              return (
                <button
                  id="download-estimate-pdf"
                  className="btn btn-primary d-none" // Removed "d-none" to make button visible for testing
                  onClick={handlePrintPDF}
                  disabled={loading || error || !blob}
                >
                  {loading ? "Generating..." : error ? "Error" : "Print Estimate PDF"}
                </button>
              );
            }}
          </BlobProvider>
          ) : (
            <button
              id="download-estimate-pdf"
              className="btn btn-primary d-none"
              disabled={true}
            >
              PDF Not Ready
            </button>
          )}

          {/* {showPDFDownload && (
            <PDFDownloadLink
              document={
                <PDFLayout
                  formData={formData}
                  repairDetails={repairDetails}
                  paymentDetails={paymentDetails}
                />
              }
              fileName={`invoice-${formData.estimate_number}.pdf`}
            >
              {({ blob, url, loading, error }) =>
                loading ? "Generating PDF..." : "Download Invoice PDF"
              }
            </PDFDownloadLink>
          )} */}
        </Form>
      </Container>
    </div>
  );
};

export default EstimateForm;
